/* eslint eqeqeq: "off" */
import React, { useEffect, useRef, useState } from "react";
import {
  Breadcrumb,
  Checkbox,
  Col,
  DatePicker,
  Divider,
  FloatButton,
  Image,
  Input,
  Modal,
  Row,
  Select,
  Spin,
  Typography,
} from "antd";
// import Slider from "react-slick";
import { MetaTags } from "react-meta-tags";
import {
  CommentOutlined,
  CloseOutlined,
  CheckOutlined,
  StarFilled,
  UserOutlined,
  CalendarOutlined,
  LeftOutlined,
  RightOutlined,
  CloseCircleOutlined,
  PlusOutlined,
  MailFilled,
  DownloadOutlined,
  ShareAltOutlined,
} from "@ant-design/icons";
import { FaLocationDot, FaMobile, FaUser } from "react-icons/fa6";
// import DashboardLogo from "../../assets/images/landing/kashmir-2.jpg";
import "./index.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import useMedia from "use-media-antd-query";
import PropTypes from "prop-types";
import { useHistory, withRouter } from "react-router";
// import { useHistory, withRouter } from "react-router";
import { IoCarSportSharp, IoShieldCheckmarkSharp } from "react-icons/io5";
import "react-range-slider-input/dist/style.css";
import { isEmpty } from "lodash";
import { FcClock, FcOnlineSupport } from "react-icons/fc";
import { packageTabs } from "./data";
// import { packageTabs, termsConditions } from "./data";
import { FaCaretRight, FaHotel, FaPhoneAlt } from "react-icons/fa";
import { PiBinocularsBold } from "react-icons/pi";
import { GiHotMeal } from "react-icons/gi";
import { useDispatch, useSelector } from "react-redux";
import SimpleReactValidator from "simple-react-validator";
import moment from "moment";
import {
  loadPackageListRecordsMetaData,
  loadPackageSingleList,
  loadTermsConditionsList,
  loadTravellerAgeRestrictions,
} from "../../store/packages/actions";
import { loadDestinationList } from "../../store/dashboard/actions";
import { emailIsValid, phoneIsValid } from "../../helpers/validations";
import api from "../../helpers";
import { toast } from "react-hot-toast";
import TourPDFContent from "./pdfTemplate";
import html2pdf from "html2pdf.js";
// import axios from "axios";
// import { toast } from "react-toastify";
// import { SampleNextArrow, SamplePrevArrow } from "../../helpers/utils";

const PackageDetailsList = (props) => {
  const media = useMedia();
  const history = useHistory();
  const packageDetailsDataId =
    props && props.location && props.location.state
      ? props.location.state._id
      : "";
  const packageDetailsExistingData =
    props && props.location && props.location.state ? props.location.state : "";

  // const history = useHistory();
  const dispatch = useDispatch();
  const simpleValidator = useRef(new SimpleReactValidator());
  const [, forceUpdate] = useState();
  const [tourTypeList, setTourTypeList] = useState([]);
  const [calculatedPriceDetails, setCalculatedPriceDetails] = useState("");
  const [calculatedPrice, setCalculatedPrice] = useState({
    startingFrom: "",
    price: "",
  });
  const [accomodationsList, setAccomodationsList] = useState([]);
  const [accomodationsChanges, setAccomodationsChanges] = useState(false);
  const [enquireModal, setEnquireModal] = useState(false);
  const [shareModal, setShareModal] = useState(false);

  //store integrations

  useEffect(() => {
    dispatch(loadTermsConditionsList());
    dispatch(
      loadTravellerAgeRestrictions("?packageId=" + packageDetailsDataId)
    );
    dispatch(loadDestinationList("?type=City"));
    dispatch(loadPackageListRecordsMetaData());
    // setTourTypeList({
    //   value: "67de50c00bce8777c6e770ce",
    //   label: "HIGH",
    // });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const { destination_list = [] } = useSelector((state) => state.Dashboard);

  const {
    packages_single_list = [],
    recordsMetaData = {},
    terms_conditions = [],
    traveller_age_restrictions = [],
  } = useSelector((state) => state.Packages);

  const destinationOptions =
    destination_list &&
    destination_list.queryResult &&
    destination_list.queryResult.length > 0
      ? destination_list.queryResult.map((data) => {
          // const imageUrl =
          //   data.images && data.images.length > 0
          //     ? data.images[0].imageUrl
          //     : "";
          return {
            label: data.destinationName,
            // images: data.images && imageUrl !== "" ? imageUrl : "",
            value: data._id,
          };
        })
      : [];

  const packageDataTable =
    packages_single_list && packages_single_list.datum
      ? packages_single_list.datum
      : [];

  const availableFacilities =
    packageDataTable &&
    packageDataTable !== "" &&
    packageDataTable.availableFacilityDetails &&
    packageDataTable.availableFacilityDetails.length > 0
      ? packageDataTable.availableFacilityDetails.map((data) => {
          return {
            label: data.facilityType,
            value: data._id,
          };
        })
      : [];

  const termsConditionsList =
    terms_conditions &&
    terms_conditions.queryResult &&
    terms_conditions.queryResult.length > 0
      ? terms_conditions.queryResult
      : [];
  const travellerAgeRestrictions =
    traveller_age_restrictions &&
    traveller_age_restrictions &&
    traveller_age_restrictions.data &&
    traveller_age_restrictions.data.length > 0
      ? traveller_age_restrictions.data[0].availabilities.flatMap((data) =>
          data.travellers.map((age) => {
            return {
              roomTypeId: data.roomTypeId,
              roomTypeName: data.roomTypeName,
              travellerAgeId: age.travellerAgeId,
              count: age.quantity,
            };
          })
        )
      : [];
  const travellerAgeDefaultRestrictions =
    traveller_age_restrictions &&
    traveller_age_restrictions.defaultValue &&
    traveller_age_restrictions.defaultValue.travellers &&
    traveller_age_restrictions.defaultValue.travellers.length > 0
      ? traveller_age_restrictions.defaultValue.travellers
      : [];

  const mappedTravellers =
    recordsMetaData &&
    recordsMetaData.travellerAgeOptions &&
    recordsMetaData.travellerAgeOptions.length > 0 &&
    travellerAgeDefaultRestrictions.length > 0
      ? recordsMetaData.travellerAgeOptions.map((ageItem) => {
          const existing =
            travellerAgeDefaultRestrictions &&
            travellerAgeDefaultRestrictions.find(
              (t) => t.travellerAgeId === ageItem._id
            );
          return {
            matchedId: existing ? existing.travellerAgeId : "",
            typeName: ageItem.typeName,
            count: existing ? existing.quantity : 0,
            age: ageItem.age,
            _id: ageItem._id,
          };
        })
      : [];

  // Update defaultValue with enriched traveller data

  useEffect(() => {
    dispatch(
      loadPackageSingleList(
        packageDetailsDataId +
          `${
            availableFacilities && availableFacilities.length > 0
              ? `?facilityId=${availableFacilities[0].value}`
              : ""
          }
          `
      )
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const packageDetailsData = {
    exclusion: packageDataTable.exclusion,
    inclusion: packageDataTable.inclusion,
    packageCode: packageDataTable.packageCode,
    packageDescription: packageDataTable.packageDescription,
    destinationId: packageDataTable.destinationId,
    itineraries: packageDataTable.itineraries,
    days:
      packageDataTable &&
      packageDataTable.itineraries &&
      packageDataTable.itineraries.length > 0
        ? packageDataTable.itineraries.length + " Days"
        : 0,
    nights:
      packageDataTable &&
      packageDataTable.itineraries &&
      packageDataTable.itineraries.length > 0
        ? parseFloat(packageDataTable.itineraries.length - 1) + " Nights"
        : 0,
    startingFrom:
      packageDataTable.lowestPrice < 10000
        ? "₹ " + parseFloat(packageDataTable.lowestPrice + 600)
        : packageDataTable.lowestPrice >= 10000 &&
          packageDataTable.lowestPrice < 20000
        ? "₹ " + parseFloat(packageDataTable.lowestPrice + 1500)
        : packageDataTable.lowestPrice >= 20000 &&
          packageDataTable.lowestPrice < 50000
        ? "₹ " + parseFloat(packageDataTable.lowestPrice + 2000)
        : packageDataTable.lowestPrice >= 50000 &&
          packageDataTable.lowestPrice < 100000
        ? "₹ " + parseFloat(packageDataTable.lowestPrice + 4000)
        : "",
    Price: "₹ " + packageDataTable.lowestPrice,
    packageCategoryId: packageDataTable.packageCategoryId,
    hotels: packageDetailsExistingData
      ? packageDetailsExistingData.hotels
      : false,
    meals: packageDetailsExistingData
      ? packageDetailsExistingData.meals
      : false,
    transport: packageDetailsExistingData
      ? packageDetailsExistingData.transport
      : false,
    sightSeeing: packageDetailsExistingData
      ? packageDetailsExistingData.sightSeeing
      : false,
    packageName: packageDataTable.packageName,
    imageUrl: packageDetailsExistingData.imageUrl
      ? packageDetailsExistingData.imageUrl
      : "",
    Duration: packageDataTable.tourPlan,
    _id: packageDataTable._id,
  };

  const dayWiseList =
    packageDataTable &&
    packageDataTable.itineraries &&
    packageDataTable.itineraries.length > 0
      ? packageDataTable.itineraries.map((data) => {
          return {
            label: data.day,
            value: data.day,
          };
        })
      : [];
  useEffect(() => {
    if (
      accomodationsChanges === false &&
      availableFacilities &&
      availableFacilities.length > 0
    ) {
      setAccomodationsList(availableFacilities[0]);
      setTourTypeList(availableFacilities[0]);
    } else if (
      accomodationsChanges === true &&
      (availableFacilities.length > 0 || availableFacilities.length == 0)
    ) {
      setAccomodationsList(accomodationsList);
      setTourTypeList(accomodationsList);
    } else {
      setAccomodationsList([]);
      setTourTypeList([]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [packages_single_list]);

  //calculate price details
  const [departureCity, setDepartureCity] = useState([]);
  const [travelDate, setTravelDate] = useState("");
  const [mobile, setMobile] = useState("");
  const [mobileValidations, setMobileValidations] = useState(false);
  const [email, setEmail] = useState("");
  const [emailValidations, setEmailValidations] = useState(false);
  const [policyAccept, setPolicyAccept] = useState("");
  const [renderPage, setRenderPage] = useState(false);

  //enquire now details
  const [packageName, setPackageName] = useState("");
  const [customerName, setCustomerName] = useState("");
  const [customerMobile, setCustomerMobile] = useState("");
  const [customerMail, setCustomerMail] = useState("");
  const [enquireLoading, setEnquireLoading] = useState(false);
  const [sharePackageButtonDisabled, setSharePackageButtonDisabled] =
    useState(false);
  const [shareLoading, setShareLoading] = useState(false);
  const [shareValidations, setShareValidations] = useState(false);
  const [customerMobileValidations, setCustomerMobileValidations] =
    useState(false);
  const [customerEmailValidations, setCustomerEmailValidations] =
    useState(false);

  //share packages pdf
  const [senderName, setSenderName] = useState("");
  const [receiverName, setReceiverName] = useState("");
  const [senderEmailValidations, setSenderEmailValidations] = useState(false);
  const [receiverEmailValidations, setReceiverEmailValidations] =
    useState(false);
  const [receiverDataEmailValidations, setReceiverDataEmailValidations] =
    useState(false);
  const [senderEmail, setSenderEmail] = useState("");
  const [sharedFile, setSharedFile] = useState(null);
  const [receiverEmail, setReceiverEmail] = useState("");
  const [pageRender, setPageRender] = useState(false);

  const [receiverDetails, setReceiverDetails] = useState([]);

  const addReceiver = () => {
    setReceiverDetails([
      ...receiverDetails,
      {
        name: "",
        email: "",
      },
    ]);
  };

  const [roomTypeList, setRoomTypeList] = useState([
    {
      label: "",
      _id: "",
      roomTypes: [
        {
          typeName: "",
          count: 0,
          age: "",
          _id: "",
          matchedId: "",
        },
      ],
    },
  ]);
  const [enquireTravellers, setEnquireTravellers] = useState([
    {
      typeName: "",
      count: 0,
      age: "",
      _id: "",
    },
  ]);

  const findMatchingTravellerAgeId = (roomTypeId) => {
    const matchedTraveller = travellerAgeRestrictions.find(
      (traveller) => traveller.travellerAgeId === roomTypeId
    );
    return matchedTraveller ? matchedTraveller.travellerAgeId : null;
  };

  // const travellerAgeOptionsArray =
  //   travellerAgeRestrictions && travellerAgeRestrictions.length > 0
  //     ? [...recordsMetaData.travellerAgeOptions, ...travellerAgeRestrictions]
  //     : [];

  const handleCountChange = (
    roomIndex,
    typeIndex,
    operation,
    travellerAgeId
  ) => {
    setRoomTypeList((prevRoomTypeList) => {
      return prevRoomTypeList.map((room, rIdx) => {
        if (rIdx === roomIndex) {
          return {
            ...room,
            roomTypes: room.roomTypes.map((type, tIdx) => {
              // Check if _id matches travellerAgeId
              if (tIdx === typeIndex && type._id === travellerAgeId) {
                // Find the required count from travellerAgeRestrictions
                const matchedTraveller = travellerAgeRestrictions.find(
                  (traveller) => traveller.travellerAgeId === travellerAgeId
                );

                if (matchedTraveller) {
                  const maxAllowed = matchedTraveller.count; // Max quantity allowed

                  let newCount =
                    operation === "increment"
                      ? Math.min(type.count + 1, maxAllowed) // Prevent exceeding max
                      : Math.max(type.count - 1, 0); // Prevent going below 0

                  return { ...type, count: newCount };
                }
              }
              return type; // Keep other types unchanged
            }),
          };
        }
        return room;
      });
    });
  };

  const handleEnquireChange = (roomIndex, change) => {
    setEnquireTravellers((prevCounts) =>
      prevCounts.map((item, i) =>
        i === roomIndex
          ? { ...item, count: Math.max(0, item.count + change) }
          : item
      )
    );
  };

  // const handleEnquireChange = (
  //   roomIndex,
  //   typeIndex,
  //   operation,
  //   travellerAgeId
  // ) => {
  //   setEnquireTravellers((prevEnquire) => {
  //     return prevEnquire.map((room, rIdx) => {
  //       if (rIdx === roomIndex) {
  //         return {
  //           ...room,
  //           roomTypes: room.map((type, tIdx) => {
  //             // Check if _id matches travellerAgeId before updating count
  //             if (tIdx === typeIndex && type._id === travellerAgeId) {
  //               return {
  //                 ...type,
  //                 count:
  //                   operation === "increment"
  //                     ? type.count + 1
  //                     : Math.max(0, type.count - 1),
  //               };
  //             }
  //             return type; // Keep other types unchanged
  //           }),
  //         };
  //       }
  //       return room;
  //     });
  //   });
  // };

  //mobile and mail validations
  const validationChange = ({ target: { value: inputValue } }) => {
    const mainInput = document.getElementById("main-input");
    const current_value = inputValue.replace(/ /g, "");
    setMobile(current_value);

    if (!phoneIsValid(current_value) && !emailIsValid(current_value)) {
      document.getElementById("error-panel").style.display = "block";
      mainInput.value = current_value;
      setMobileValidations(true);
    } else {
      document.getElementById("error-panel").style.display = "none";
      if (phoneIsValid(current_value)) {
        const phoneNumberArr = [...current_value.matchAll(/\d{2}/g)].map(
          (x) => x["0"]
        );
        mainInput.value = phoneNumberArr.join(" ");
        // setuserValue(true);
      }
      setMobileValidations(false);
    }
  };

  //Email validation changes
  const validationEmailChange = ({ target: { value: inputValue } }) => {
    const mainInput = document.getElementById("main-email-input");
    const current_value = inputValue.replace(/ /g, "");
    setEmail(current_value);

    if (!emailIsValid(current_value)) {
      document.getElementById("error-email-panel").style.display = "block";
      mainInput.value = current_value;
      setEmailValidations(true);
    } else {
      document.getElementById("error-email-panel").style.display = "none";
      setEmailValidations(false);
    }
  };
  //Share  validation changes
  const validationSenderEmailChange = ({ target: { value: inputValue } }) => {
    const mainInput = document.getElementById("main-sender-email-input");
    const current_value = inputValue.replace(/ /g, "");
    setSenderEmail(current_value);

    if (!emailIsValid(current_value)) {
      document.getElementById("error-sender-email-panel").style.display =
        "block";
      mainInput.value = current_value;
      setSenderEmailValidations(true);
    } else {
      document.getElementById("error-sender-email-panel").style.display =
        "none";
      setSenderEmailValidations(false);
    }
  };
  const validationReceiverEmailChange = ({ target: { value: inputValue } }) => {
    const mainInput = document.getElementById("main-receiver-email-input");
    const current_value = inputValue.replace(/ /g, "");
    setReceiverEmail(current_value);

    if (!emailIsValid(current_value)) {
      document.getElementById("error-receiver-email-panel").style.display =
        "block";
      mainInput.value = current_value;
      setReceiverEmailValidations(true);
    } else {
      document.getElementById("error-receiver-email-panel").style.display =
        "none";
      setReceiverEmailValidations(false);
    }
  };

  //mobile and mail validations
  const validationEnquireChange = ({ target: { value: inputValue } }) => {
    const mainInput = document.getElementById("main-enquire-input");
    const current_value = inputValue.replace(/ /g, "");
    setCustomerMobile(current_value);

    if (!phoneIsValid(current_value) && !emailIsValid(current_value)) {
      document.getElementById("error-enquire-panel").style.display = "block";
      mainInput.value = current_value;
      setCustomerMobileValidations(true);
    } else {
      document.getElementById("error-enquire-panel").style.display = "none";
      if (phoneIsValid(current_value)) {
        const phoneNumberArr = [...current_value.matchAll(/\d{2}/g)].map(
          (x) => x["0"]
        );
        mainInput.value = phoneNumberArr.join(" ");
        // setuserValue(true);
      }
      setCustomerMobileValidations(false);
    }
  };

  //Email validation changes
  const validationEnquireEmailChange = ({ target: { value: inputValue } }) => {
    const mainInput = document.getElementById("main-enquire-email-input");
    const current_value = inputValue.replace(/ /g, "");
    setCustomerMail(current_value);

    if (!emailIsValid(current_value)) {
      document.getElementById("error-enquire-email-panel").style.display =
        "block";
      mainInput.value = current_value;
      setCustomerEmailValidations(true);
    } else {
      document.getElementById("error-enquire-email-panel").style.display =
        "none";
      setCustomerEmailValidations(false);
    }
  };

  useEffect(() => {
    if (recordsMetaData && recordsMetaData.travellerAgeOptions) {
      // let matchedIdArray = [];
      // const ageTypeOptions =
      //     travellerAgeRestrictions &&
      //     recordsMetaData.travellerAgeOptions.length > 0
      //       ? recordsMetaData.travellerAgeOptions.forEach((ageItem) => {
      //           const matchedRoom = travellerAgeRestrictions.find(
      //             (roomItem) =>
      //               roomItem.travellerAgeId === ageItem._id && roomItem.count >= 1
      //           );

      //           if (matchedRoom) {
      //             return {
      //               ...ageItem,
      //               // matchedId: matchedRoom.roomTypeId,
      //               count: matchedRoom.count
      //             };
      //           } else {
      //             return {
      //               ...ageItem,
      //             };
      //           }

      //           // return ageItem;
      //         })
      //       : [];

      // Replace original ageArray with matched entries
      // recordsMetaData.travellerAgeOptions = matchedIdArray;
      setRoomTypeList([
        {
          label: "",
          _id: "",
          roomTypes:
            mappedTravellers.length > 0
              ? mappedTravellers
              : recordsMetaData.travellerAgeOptions,
        },
      ]);
      setEnquireTravellers(recordsMetaData.travellerAgeOptions);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [recordsMetaData]);

  const addRoomDetails = () => {
    setRenderPage(!renderPage);
    setRoomTypeList([
      ...roomTypeList,
      {
        label: "",
        _id: "",
        roomTypes: recordsMetaData.travellerAgeOptions,
      },
    ]);
  };
  const removeRoomTypes = (index) => {
    const array = [...roomTypeList];
    array.splice(index, 1);
    setRoomTypeList(array);
    setRenderPage(!renderPage);
  };

  const [buttonDisabled, setButtonDisabled] = useState(false);
  const [bookingButtonDisabled, setBookingButtonDisabled] = useState(false);
  const [enquireNowButtonDisabled, setEnquireNowButtonDisabled] =
    useState(false);
  const [enquireValidations, setEnquireValidations] = useState(false);
  const date = travelDate ? moment(travelDate, "Do MMMM YYYY") : "";

  const packages = {
    facilityId: tourTypeList ? tourTypeList.value : "",
    packageId: packageDetailsDataId,
    // dateOfTravel: travelDate ? moment(travelDate).format("DD-MM-YYYY") : "",
    dateOfTravel: date ? moment(date).format("YYYY-MM-DD") : "",
    mobileNo: mobile,
    email: email,
    rooms:
      roomTypeList && roomTypeList.length > 0
        ? roomTypeList.flatMap((data) => {
            return {
              members: data.roomTypes
                .filter((roomType) => roomType.count !== 0)
                .map((room) => {
                  return {
                    travellerAgeId: room._id,
                    quantity: room.count,
                  };
                }),
            };
          })
        : [],
    departureFrom: departureCity ? departureCity.value : "",
  };
  const calculatePriceDetails = () => {
    if (simpleValidator.current.allValid()) {
      setButtonDisabled(true);
      setTimeout(() => {
        setButtonDisabled(false);
      }, 3000);

      api
        .post("/calculatePrice/create", packages)
        // .post("/enquiry/create", packages)
        .then((res) => {
          toast.success("Price Calculated");
          setCalculatedPriceDetails(res.data.datum);
          const priceValue =
            res.data && res.data.datum && res.data.datum.finalPrice
              ? res.data.datum.finalPrice
              : "";
          const priceValueData =
            priceValue < 10000
              ? parseFloat(priceValue + 600)
              : priceValue >= 10000 && priceValue < 20000
              ? parseFloat(priceValue + 1500)
              : priceValue >= 20000 && priceValue < 50000
              ? parseFloat(priceValue + 2000)
              : priceValue >= 50000 && priceValue < 100000
              ? parseFloat(priceValue + 4000)
              : "";
          setCalculatedPrice({
            price: priceValue == 0 ? 0 : priceValue,
            startingFrom: priceValue == 0 ? 0 : priceValueData,
          });
          // setPriceValueDetails(priceValueData)
          return res.data;
        })
        .catch((error) => {
          const errorMsg =
            (error &&
              error.response &&
              error.response.data &&
              error.response.data.error) ||
            (error &&
              error.response &&
              error.response.data &&
              error.response.data.message);
          toast.error(
            errorMsg || "There is an issue while calculate the price"
          );
          Promise.reject(error);
        });
    } else {
      simpleValidator.current.showMessages();
      forceUpdate(1);
    }
  };

  // const travelPayload =  travelDate
  //   ? moment(travelDate).format("DD-MM-YYYY")
  //   : "";

  // Convert to DD-MM-YYYY format
  const travelPayload = date ? date.format("DD-MM-YYYY") : "";
  const addBooking = () => {
    // setPackageTabDetails("Calculate Price");
    setTimeout(() => {
      if (simpleValidator.current.allValid()) {
        setBookingButtonDisabled(true);
        const packages = {
          facilityId: tourTypeList ? tourTypeList.value : "",
          packageId: packageDetailsDataId,
          dateOfTravel: travelDate ? travelPayload : "",
          mobileNo: mobile,
          email: email,
          rooms:
            roomTypeList && roomTypeList.length > 0
              ? roomTypeList.flatMap((data) => {
                  return {
                    members: data.roomTypes
                      .filter((roomType) => roomType.count !== 0)
                      .map((room) => {
                        return {
                          travellerAgeId: room._id,
                          quantity: room.count,
                          ageType: room.typeName,
                        };
                      }),
                  };
                })
              : [],
          destinationFrom: departureCity ? departureCity.value : "",
        };
        setTimeout(() => {
          setBookingButtonDisabled(false);
          if (calculatedPrice.price > 0) {
            history.push({
              pathname: `/booking/travellers/${
                calculatedPriceDetails !== undefined &&
                calculatedPriceDetails.priceEnquiryNo
                  ? calculatedPriceDetails.priceEnquiryNo
                  : ""
              }`,
              state: {
                data: packages,
                packageData: packageDetailsData,
                priceData: calculatedPriceDetails,
              },
            });
          } else {
            toast.error(
              "Package value greater than 0 only should be process for booking"
            );
          }
        }, 3000);
      } else {
        simpleValidator.current.showMessages();
        forceUpdate(1);
      }
    }, 1500);
  };

  const shareDetailsChange = (e, name, index) => {
    let shareList = receiverDetails;

    if (name == "name") {
      e = e.target.value;
      shareList[index]["name"] = e;
      setReceiverDetails(shareList);
      setPageRender(!pageRender);
    }
    if (name == "email") {
      e = e.target.value;
      const mainInput = document.getElementById(
        "main-receiver-data-email-input"
      );
      const current_value = e.replace(/ /g, "");
      shareList[index]["email"] = current_value;
      // setSenderEmail(current_value);

      if (!emailIsValid(current_value)) {
        document.getElementById(index).style.display = "block";
        mainInput.value = current_value;
        setReceiverDataEmailValidations(true);
      } else {
        document.getElementById(index).style.display = "none";
        setReceiverDataEmailValidations(false);
      }
      setReceiverDetails(shareList);
      setPageRender(!pageRender);
    }
  };

  const addEquireForm = () => {
    setEnquireModal(true);
    setPackageName(packageDataTable.packageName);
    setCustomerMail("");
    setCustomerMobile("");
    setCustomerName("");
    setEnquireValidations(false);
    setCustomerMobileValidations(false);
    setCustomerEmailValidations(false);
  };

  const travellerDetails =
    enquireTravellers && enquireTravellers.length > 0
      ? enquireTravellers.filter((enquiry) => enquiry.count !== 0)
      : [];

  const enquireNowDetails = () => {
    // setPackageTabDetails("Calculate Price");
    if (
      travellerDetails.length > 0 &&
      customerMobile !== "" &&
      customerMail !== "" &&
      customerName !== ""
    ) {
      setEnquireNowButtonDisabled(true);
      setTimeout(() => {
        setEnquireNowButtonDisabled(false);
      }, 3000);
      const packages = {
        packageId: packageDetailsDataId,
        mobileNo: parseFloat(customerMobile),
        name: customerName,
        emailId: customerMail,
        // facilityId:
        //   tourTypeList && tourTypeList.value ? tourTypeList.value : "",
        travellers:
          enquireTravellers && enquireTravellers.length > 0
            ? enquireTravellers
                .filter((enquiry) => enquiry.count !== 0)
                .map((data) => {
                  return {
                    travellerAgeId: data._id,
                    quantity: data.count,
                  };
                })
            : [],
      };
      api
        .post("/enquiry/create", packages)
        .then((res) => {
          setEnquireLoading(true);
          setTimeout(() => {
            setEnquireLoading(false);
            setEnquireModal(false);
            setEnquireValidations(false);
            history.push({
              pathname: `/enquiry/${
                res.data.datum && res.data.datum.enquireNo
              }`,
              state: res.data && res.data.datum,
            });
          }, 1500);
          return res.data;
        })
        .catch((error) => {
          const errorMsg =
            (error &&
              error.response &&
              error.response.data &&
              error.response.data.error) ||
            (error &&
              error.response &&
              error.response.data &&
              error.response.data.msg);
          toast.error(
            errorMsg || "There is an issue while calculate the price"
          );
          Promise.reject(error);
        });
    } else {
      if (travellerDetails.length == 0) {
        toast.error("Choose the traveller details");
        setEnquireNowButtonDisabled(true);
        setTimeout(() => {
          setEnquireNowButtonDisabled(false);
        }, 3000);
      }
      setEnquireValidations(true);
    }
  };

  const handleSharePDF = async () => {
    const element = document.getElementById("share-pdf");

    const opt = {
      margin: 1,
      filename: "shared.pdf",
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: "in", format: "a4", orientation: "portrait" },
    };
    const worker = html2pdf().set(opt).from(element);
    console.log(worker, "worker");
    const blob = worker.outputPdf("blob");
    console.log(blob, "blob");
    const file = new File([blob], "shared.pdf", { type: "application/pdf" });
    console.log(file, "file pdf");
    // const formData = new FormData();
    // formData.append("file", blob);
    // console.log(formData.get("file")); // should log the File object
    setSharedFile(file);
  };

  const ccDetailsArray =
    receiverDetails.length > 0 && receiverDetails[0].name
      ? receiverDetails.map((data) => {
          return {
            name: data.name,
            email: data.email,
          };
        })
      : [];
  // const ccDetails =
  //   ccDetailsArray && ccDetailsArray.length > 0
  //     ? JSON.stringify(ccDetailsArray)
  //     : [];

  const sharePackageDetails = async () => {
    if (
      senderName !== "" &&
      senderEmail !== "" &&
      receiverName !== "" &&
      receiverEmail !== ""
    ) {
      setSharePackageButtonDisabled(true);
      setTimeout(() => {
        setSharePackageButtonDisabled(false);
      }, 3000);
      // const formData = new FormData();
      // formData.append("file", sharedFile);
      // console.log(formData, "formData")
      // const shareDetails = {
      //   file: sharedFile,
      //   senderName: senderName,
      //   senderEmail: senderEmail,
      //   receiverName: receiverName,
      //   receiverEmail: receiverEmail,
      //   cc: receiverDetails.length > 0 ? ccDetailsArray : [],
      // };
      const formData = new FormData();
      formData.append("file", sharedFile); // PDF File object
      formData.append("senderName", senderName);
      formData.append("senderEmail", senderEmail);
      formData.append("receiverName", receiverName);
      formData.append("receiverEmail", receiverEmail);
      formData.append(
        "cc",
        receiverDetails.length > 0 ? JSON.stringify(ccDetailsArray) : []
      );
      console.log(formData, "formData");
      if (receiverDetails.length === 0) {
        formData.delete("cc");
      }
      await fetch(
        "https://pmtuserapi.mequalsvps.in/package/send-price-calculation-email",
        { method: "POST", body: formData }
      );
      // await api
      //   .post("/package/send-price-calculation-email", shareDetails)
      // .then((res) => {
      //   setShareLoading(true);
      //   setTimeout(() => {
      //     setShareLoading(false);
      //     setShareModal(false);
      //     setShareValidations(false);
      //   }, 1500);
      //   return res.data;
      // })
      // .catch((error) => {
      //   const errorMsg =
      //     (error &&
      //       error.response &&
      //       error.response.data &&
      //       error.response.data.error) ||
      //     (error &&
      //       error.response &&
      //       error.response.data &&
      //       error.response.data.msg);
      //   toast.error(errorMsg || "There is an issue while sharing the file");
      //   Promise.reject(error);
      // });
    } else {
      setShareValidations(true);
    }
  };

  const [hideTop, setHideTop] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        // Adjust the scroll threshold as needed
        setHideTop(true);
      } else {
        setHideTop(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  //Initial state

  const [packageTabDetails, setPackageTabDetails] = useState("Overview");
  const [chatModal, setChatModal] = useState(false);
  const [daySelected, setDaySelected] = useState(1);
  const sectionRefs = useRef([]);

  // Function to scroll to the selected day
  const scrollToDay = (index) => {
    const element = sectionRefs.current[index];
    if (element) {
      const offsetTop = element.offsetTop + 350; // Adjust 100px for navbar or padding
      window.scrollTo({ top: offsetTop, behavior: "smooth" });
    }
  };

  const [isFixed, setIsFixed] = useState(false);
  const [isPackagefixed, setIsPackagefixed] = useState(false);
  const containerRef = useRef(null);
  const placeholderRef = useRef(null);
  const componentRef = useRef(null);
  let scrollTimeout = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      const footer = document.getElementById("footer"); // Replace with actual footer ID
      const startScrollThreshold = 120; // Start scroll after 100px

      if (footer) {
        const footerTop = footer.getBoundingClientRect().top;
        const windowHeight = window.innerHeight;

        // If user scrolled more than 100px, start fixing the container
        if (scrollY >= startScrollThreshold) {
          setIsFixed(true);
        } else {
          setIsFixed(false);
        }

        // If footer comes into view, stop fixing the container
        if (footerTop <= windowHeight) {
          setIsFixed(false);
        }
      }

      // Clear previous timeout
      if (scrollTimeout.current) clearTimeout(scrollTimeout.current);

      // Detect when scrolling stops
      scrollTimeout.current = setTimeout(() => {
        if (scrollY < startScrollThreshold) {
          setIsFixed(false);
        }
      }, 200);
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
      if (scrollTimeout.current) clearTimeout(scrollTimeout.current);
    };
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      if (containerRef.current && placeholderRef.current) {
        const placeholderTop =
          placeholderRef.current.getBoundingClientRect().top;

        if (placeholderTop <= 100) {
          // Once the placeholder reaches 100px from the top, fix it
          setIsPackagefixed(true);
        } else {
          // If we scroll back up, remove fixed positioning
          setIsPackagefixed(false);
        }
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const StarRating = ({ rating }) => {
    return (
      <div style={{ fontSize: "24px", color: "#f1c40f" }}>
        {"★".repeat(rating)}
      </div>
    );
  };

  const pdfComponentRef = useRef();

  const handleDownload = () => {
    pdfComponentRef.current?.downloadPDF();
    setShareLoading(true);
    setTimeout(() => {
      setShareLoading(false);
    }, 4500);
  };

  return (
    <React.Fragment>
      <div className="">
        <MetaTags>
          <title>Package-details | Plan mi trip</title>
        </MetaTags>
      </div>
      <Row
        className={
          media == "sm"
            ? "pr-[6%] pl-[6%] w-[100%]"
            : media == "xs"
            ? "pr-[40px] pl-[40px] w-[100%]"
            : media == "md"
            ? "pr-[7%] pl-[7%] w-[100%]"
            : media == "lg"
            ? "pr-[10%] pl-[10%] w-[100%] mt-[80px]"
            : media == "xxl"
            ? "pr-[9%] pl-[11%] w-[100%]"
            : "pr-[8%] pl-[6.5%] w-[100%]"
          // media === "md"
          //   ? "mt-10 pl-[140px] pr-[120px] w-[100%]"
          //   : media == "sm" || media == "xs"
          //   ? "pl-[40px] pr-[30px] w-[100%]"
          //   : "pl-[140px] pr-[120px] w-[100%]"
        }
      >
        <Col md={24} sm={24} xs={24} lg={24} xl={24} xxl={24}>
          <Breadcrumb
            style={{
              fontFamily: "Poppins",
              color: "blue",
              fontSize: "12px",
            }}
            items={[
              {
                href: "/",
                title: "Home",
                separator: ">",
              },
              {
                path: "/packages",
                title: "Packages",
                separator: ">",
              },
              {
                // path: "/packages",
                title: "Package Details",
              },
            ]}
          />
        </Col>
        <Col
          md={24}
          sm={24}
          xs={24}
          lg={24}
          xl={24}
          xxl={24}
          className="relative"
        >
          <Row className="">
            <Col md={24} sm={24} xs={24} lg={24} xl={24} xxl={24}>
              <div className="flex flex-row">
                <h1 className="package-fonts text-[20px] font-extrabold">
                  {!isEmpty(packageDetailsData)
                    ? packageDetailsData.packageName
                    : ""}
                </h1>
                <p className="ml-3 mt-[8px] package-fonts text-[11px] font-semibold">
                  {" "}
                  {packageDataTable && packageDataTable.totalDayAndNight
                    ? packageDataTable.totalDayAndNight
                    : !isEmpty(packageDetailsData)
                    ? packageDetailsData.nights +
                      " / " +
                      packageDetailsData.days
                    : ""}
                </p>
              </div>
              <div className="package-fonts text-[12px] mt-2 font-medium">
                {!isEmpty(packageDetailsData)
                  ? packageDetailsData.Duration
                  : ""}
              </div>
            </Col>
          </Row>
          <Row className="mt-3 relative">
            <Col md={24} sm={24} xs={24} lg={24} xl={24} xxl={24}>
              <Row>
                <Col md={24} sm={24} xs={24} lg={17} xl={17} xxl={17}>
                  <Image
                    src={
                      !isEmpty(packageDetailsData)
                        ? packageDetailsData.imageUrl
                        : ""
                    }
                    preview={false}
                    width={"100%"}
                    className="rounded-xl"
                    // height={"360"}
                    // style={{
                    //   backgroundSize: "cover",
                    // }}
                  />
                  <Row>
                    <div
                      ref={placeholderRef}
                      style={{
                        height: isPackagefixed
                          ? containerRef.current?.offsetHeight
                          : "auto",
                      }}
                    ></div>
                    <Col
                      md={24}
                      sm={24}
                      xs={24}
                      lg={24}
                      xl={24}
                      xxl={24}
                      ref={containerRef}
                      className={`flex flex-row mt-3 scroll-container ${
                        isPackagefixed && media === "xxl" && hideTop == true
                          ? "scroll-extra-extra-large-package-fixed-and-hide-top"
                          : isPackagefixed &&
                            media === "xxl" &&
                            hideTop == false
                          ? "scroll-extra-extra-large-package-fixed"
                          : isPackagefixed && media === "xl" && hideTop == true
                          ? "scroll-extra-large-package-fixed-and-hide-top"
                          : isPackagefixed && media === "xl" && hideTop == false
                          ? "scroll-extra-large-package-fixed"
                          : isPackagefixed && media == "lg" && hideTop == true
                          ? "scroll-medium-device-package-fixed-and-hide-top mt-[30px]"
                          : isPackagefixed && media == "lg" && hideTop == false
                          ? "scroll-medium-device-package-fixed mt-[30px]"
                          : isPackagefixed && media == "md" && hideTop == true
                          ? "scroll-medium-package-device-fixed-and-hide-top mt-[30px]"
                          : isPackagefixed && media == "md" && hideTop == false
                          ? "scroll-medium-package-device-fixed mt-[30px]"
                          : isPackagefixed &&
                            (media === "xs" || media == "sm") &&
                            hideTop == true
                          ? "scroll-package-fixed-and-hide-top"
                          : isPackagefixed &&
                            (media === "xs" || media == "sm") &&
                            hideTop == false
                          ? "scroll-package-fixed"
                          : "flex flex-row mt-3"
                      }`}
                      style={{
                        fontFamily: "Poppins",
                        fontSize: "13px",
                        // position: "fixed",
                        // top: 0,
                        // left: 0,
                      }}
                    >
                      {packageTabs.map((data, index) => {
                        return (
                          <div
                            key={index}
                            onClick={() => {
                              setPackageTabDetails(data.label);
                              // if (packageTabDetails == "Overview") {
                              //   const element =
                              //     document.getElementById("overview");
                              //   const offsetHeight = element.offsetHeight + 350;
                              //   window.scrollTo({
                              //     top: offsetHeight,
                              //     behavior: "smooth",
                              //   });
                              // } else if (
                              //   packageTabDetails == "Day wise Itinery"
                              // ) {
                              //   const element =
                              //     document.getElementById("itinery");
                              //   const offsetHeight = element.offsetHeight + 350;
                              //   window.scrollTo({
                              //     top: offsetHeight,
                              //     behavior: "smooth",
                              //   });
                              // } else if (
                              //   packageTabDetails == "Inclusions/Exclusions"
                              // ) {
                              //   const element =
                              //     document.getElementById("inclusion");
                              //   const offsetHeight = element.offsetHeight + 350;
                              //   window.scrollTo({
                              //     top: offsetHeight,
                              //     behavior: "smooth",
                              //   });
                              // } else if (
                              //   packageTabDetails == "Additional Info"
                              // ) {
                              //   const element =
                              //     document.getElementById("additionalInfo");
                              //   const offsetHeight = element.offsetHeight + 350;
                              //   window.scrollTo({
                              //     top: offsetHeight,
                              //     behavior: "smooth",
                              //   });
                              // }
                            }}
                            className={
                              packageTabDetails == data.label
                                ? "bg-[#eb3e43] cursor-pointer text-[white] p-2 mr-4"
                                : "text-[gray] hover:bg-[#eb3e43] hover:text-[white] cursor-pointer p-2 mr-4"
                            }
                            style={{
                              borderRadius: "24px",
                            }}
                          >
                            <h1
                              style={{
                                display:
                                  media === "sm" ||
                                  media === "xs" ||
                                  media === "md" ||
                                  media === "lg"
                                    ? ""
                                    : "inline-block",
                                width:
                                  media === "sm" ||
                                  media === "xs" ||
                                  media === "md" ||
                                  media === "lg"
                                    ? ""
                                    : "max-content",
                              }}
                              className="font-semibold"
                            >
                              {data.label}
                            </h1>
                          </div>
                        );
                      })}
                    </Col>
                    {packageTabDetails === "Day wise Itinerary" ? (
                      <Col md={24} sm={24} xs={24} lg={24} xl={24} xxl={24}>
                        <Row>
                          <Col
                            md={24}
                            sm={24}
                            xs={24}
                            lg={24}
                            xl={24}
                            xxl={24}
                            className="flex flex-row bg-[white] border border-1 rounded-sm shadow-md p-2 mt-3"
                            style={{
                              fontFamily: "Poppins",
                              // position: "fixed",
                            }}
                            id="itinery"
                          >
                            <div className="w-[100%] mb-[-10px]">
                              <div className="w-[100%] flex border border-b-2 pb-1 border-t-0 border-x-0">
                                <p className="w-[4px] bg-[#eb3e43] h-[20px] mr-2 ml-[-8px]"></p>
                                <h1 className="text-[16px] font-semibold">
                                  Day wise Itinerary
                                </h1>
                              </div>
                              <div className="flex justify-between pt-3 pb-3 pr-2 pl-2 w-[100%] flex border border-b-2 pb-1 border-t-0 border-x-0">
                                <div className="flex">
                                  <h1 className="text-[16px] font-medium">
                                    Day
                                  </h1>
                                  <div
                                    className="ml-3 mr-6 mt-1"
                                    onClick={() => {
                                      if (daySelected == 1) {
                                        setDaySelected(1);
                                        scrollToDay(1);
                                      } else {
                                        setDaySelected(daySelected - 1);
                                        scrollToDay(daySelected - 1);
                                      }
                                    }}
                                  >
                                    <LeftOutlined className="text-[#eb3e43] text-[16px] font-semibold cursor-pointer" />
                                  </div>
                                  {dayWiseList.map((data, index) => {
                                    return (
                                      <div
                                        key={index}
                                        onClick={() => {
                                          setDaySelected(data.label);
                                          scrollToDay(index);
                                          // var elementView = document.getElementById(
                                          //   data.label
                                          // );

                                          // elementView &&
                                          //   elementView.scrollIntoView({
                                          //     behavior: "smooth",
                                          //     block: "start",
                                          //     inline: "start",
                                          //   });
                                        }}
                                        className={
                                          daySelected === data.label
                                            ? "mt-[2px] mb-[-14px] cursor-pointer mr-4 pl-5 pr-5 pb-3 font-semibold text-[16px] border border-b-4 border-t-0 border-x-0 border-[#eb3e43] package-fonts font-semibold"
                                            : "mt-[2px] mb-[-14px] cursor-pointer mr-4 pl-5 pr-5 pb-3 font-medium text-[16px] package-fonts font-medium"
                                        }
                                      >
                                        <h1 className="text-center">
                                          {data.label}
                                        </h1>
                                      </div>
                                    );
                                  })}
                                </div>
                                <div
                                  className="mt-1"
                                  onClick={() => {
                                    if (daySelected == dayWiseList.length) {
                                      setDaySelected(daySelected);
                                      // scrollToDay(daySelected);
                                    } else {
                                      setDaySelected(daySelected + 1);
                                      // scrollToDay(daySelected + 1);
                                    }
                                  }}
                                >
                                  <RightOutlined className="text-[#eb3e43] text-[16px] font-semibold cursor-pointer" />
                                </div>
                              </div>
                            </div>
                          </Col>
                          {/* {daySelected == 1 ? ( */}
                          {packageDetailsData &&
                          packageDetailsData.itineraries &&
                          packageDetailsData.itineraries.length > 0
                            ? packageDetailsData.itineraries
                                .filter((itinery) => itinery.day == daySelected)
                                .map((data, index) => {
                                  const imageUrlData =
                                    data.images && data.images.length > 0
                                      ? data.images[0].imageUrl
                                      : "";
                                  return (
                                    <div key={index} className="w-[100%]">
                                      <Row
                                        style={{
                                          boxShadow: "1px 2px 2px 1px #f1f1f1",
                                        }}
                                        className="w-[100%] bg-[white] border border-1 rounded-xl mt-3"
                                      >
                                        <Col
                                          md={24}
                                          sm={24}
                                          xs={24}
                                          lg={24}
                                          xl={24}
                                          xxl={24}
                                          className="p-2"
                                        >
                                          <Image
                                            src={imageUrlData}
                                            preview={false}
                                            width={"100%"}
                                            height={380}
                                            className="mt-2border border-1"
                                          />

                                          <div className="package-fonts text-[12px] font-semibold w-[100%] border border-b-1 border-x-0 border-t-0 pt-5 pb-5 pr-3 pl-3 mb-5">
                                            <div
                                              // id="output"
                                              className="text-[12px] mt-2 ml-1"
                                              dangerouslySetInnerHTML={{
                                                __html: data
                                                  ? data.description
                                                  : "",
                                              }} // Render HTML safely
                                            ></div>
                                            {/* <p className="mb-3">
                                              Arrival in Kashmir Welcome to
                                              Kashmir and transfer to hotel.
                                            </p>
                                            <p className="mb-3">
                                              Check into your hotel and relax.
                                            </p>
                                            <p className="mb-3">
                                              Lunch at the hotel.
                                            </p>
                                            <p className="mb-3">
                                              Enjoy leisure time (explore the
                                              local markets for souvenirs) – on
                                              your own.
                                            </p>
                                            <p>
                                              Dinner and overnight stay in
                                              Kashmir at the hotel.
                                            </p> */}
                                          </div>
                                        </Col>
                                      </Row>
                                      <Row
                                        style={{
                                          boxShadow: "1px 2px 2px 1px #f1f1f1",
                                        }}
                                        className="w-[100%] bg-[white] rounded-xl border border-1 mt-4"
                                      >
                                        <Col
                                          md={24}
                                          sm={24}
                                          xs={24}
                                          lg={24}
                                          xl={24}
                                          xxl={24}
                                          className="p-2"
                                        >
                                          <div className="flex package-fonts border border-b-1 pb-3 border-t-0 border-x-0">
                                            <PiBinocularsBold className="text-[16px] font-semibold mt-[2px] text-[#eb3e43] mr-2" />
                                            <p className="font-semibold">
                                              Highlights
                                            </p>
                                          </div>
                                        </Col>
                                        <Col
                                          md={24}
                                          sm={24}
                                          xs={24}
                                          lg={24}
                                          xl={24}
                                          xxl={24}
                                          className="p-2"
                                        >
                                          <div className="package-fonts text-[12px] w-[100%] border border-b-1 border-x-0 border-t-0 pt-2 pb-5 pr-3 pl-3 mb-5">
                                            <div
                                              // id="output"
                                              className="text-[12px] mt-2 ml-1"
                                              dangerouslySetInnerHTML={{
                                                __html: data
                                                  ? data.highlights
                                                  : "",
                                              }} // Render HTML safely
                                            ></div>
                                            {/* <p className="mb-3 font-semibold">
                                              This Kashmir Tour is a fully
                                              loaded group holidays, with
                                              flights, all meals, evening
                                              tea/coffee & snacks, sightseeing
                                              with entrances, Tour Manager,
                                              Insurance under 69 yrs.,
                                              sightseeing with all entrances
                                            </p>
                                            <p className="mb-3">
                                              Stay in Standard 3* Hotels in
                                              Gulmarg, Srinagar, Pahalgam
                                            </p>
                                            <p className="mb-3">
                                              {" "}
                                              Stay in Houseboat on Dal Lake
                                            </p>
                                            <p className="mb-3">
                                              All Meals and Evening Tea/Coffee
                                              with Snacks{" "}
                                            </p>
                                            <p className="mb-3">
                                              Enjoy Shikara ride on Dal Lake
                                              till Char Chinar
                                            </p>
                                            <p className="mb-3">
                                              Ride the Gulmarg Gondola up to
                                              Phase 1 and enjoy snow activities
                                              (weather permitting)
                                            </p>
                                            <p>
                                              All Must See Sightseeing with all
                                              entrances- Dal Lake(Char Chinar),
                                              Shankaracharya Temple, Nishat
                                              Bagh, Pari Mahal, Awantipura
                                              Ruins, Betaab Valley Chandanwari,
                                              Martand Sun Temple, Kashmiri
                                              Cricket Bat Factory, Pir Panjal
                                              Mountains and Valley, Excursion
                                              Sonmarg
                                            </p> */}
                                          </div>
                                        </Col>
                                      </Row>
                                    </div>
                                  );
                                })
                            : ""}
                          {/* ) : (
                            ""
                          )} */}
                        </Row>
                      </Col>
                    ) : packageTabDetails === "Inclusions/Exclusions" ? (
                      <Col
                        md={24}
                        sm={24}
                        xs={24}
                        lg={24}
                        xl={24}
                        xxl={24}
                        className="flex"
                        style={{
                          fontFamily: "Poppins",
                        }}
                        id="inclusion"
                      >
                        <div className="w-[100%] bg-[white] border border-1 rounded-xl shadow-md pt-4 pr-4 pl-4 mt-3 pb-4">
                          <Row className="w-[100%] flex flex-row">
                            <Col
                              md={12}
                              sm={12}
                              xs={12}
                              lg={12}
                              xl={12}
                              xxl={12}
                              className="package-fonts h-[100%] pr-3"
                            >
                              <div className="w-[100%] bg-[#30d16e30] border border-1 rounded-xl shadow-md p-2 mt-3 pb-2">
                                <div className="w-[100%] flex pb-1">
                                  <p className="w-[4px] bg-[#eb3e43] h-[20px] mr-2 ml-[-8px]"></p>
                                  <h1 className="text-[16px] font-semibold">
                                    Inclusions
                                  </h1>
                                </div>
                                <div className="ml-1 mt-1">
                                  {packageDataTable &&
                                  packageDataTable.inclusion.length > 0
                                    ? packageDataTable.inclusion.map(
                                        (data, index) => {
                                          return (
                                            <div
                                              key={index}
                                              className="mb-1 flex"
                                            >
                                              <p>
                                                <CheckOutlined className="text-[green] text-[12px]" />
                                              </p>
                                              <h1 className="text-[11px] ml-2 mt-[2px]">
                                                {data}
                                              </h1>
                                            </div>
                                          );
                                        }
                                      )
                                    : ""}
                                </div>
                              </div>
                            </Col>
                            <Col
                              md={12}
                              sm={12}
                              xs={12}
                              lg={12}
                              xl={12}
                              xxl={12}
                              className="h-[100%] package-fonts"
                            >
                              <div className="w-[100%] bg-[#e95d5d1f] border border-1 rounded-xl shadow-md p-2 mt-3 pb-2">
                                <div className="w-[100%] flex pb-1">
                                  <p className="w-[4px] bg-[#eb3e43] h-[20px] mr-2 ml-[-8px]"></p>
                                  <h1 className="text-[16px] font-semibold">
                                    Exclusions
                                  </h1>
                                </div>
                                <div className="ml-1 mt-1">
                                  {packageDataTable &&
                                  packageDataTable.exclusion.length > 0
                                    ? packageDataTable.exclusion.map(
                                        (data, index) => {
                                          return (
                                            <div
                                              key={index}
                                              className="mb-1 flex"
                                            >
                                              <p>
                                                <CloseOutlined className="text-[#eb3e43] text-[12px]" />
                                              </p>
                                              <h1 className="text-[11px] ml-2 mt-[2px]">
                                                {data}
                                              </h1>
                                            </div>
                                          );
                                        }
                                      )
                                    : ""}
                                </div>
                              </div>
                            </Col>
                          </Row>
                        </div>
                      </Col>
                    ) : packageTabDetails === "Calculate Price" ? (
                      <Col className="w-[100%]">
                        <Row>
                          <Col
                            md={24}
                            sm={24}
                            xs={24}
                            lg={24}
                            xl={24}
                            xxl={24}
                            id="additionalInfo"
                            className="w-[100%] bg-[white] border border-1 rounded-xl shadow-md pl-3 pr-3 pb-3 pt-2 mt-3 pb-2 package-fonts mt-3"
                          >
                            <div className="w-[100%] flex pb-1">
                              <p className="w-[4px] bg-[#eb3e43] h-[20px] mr-2 ml-[-12px]"></p>
                              <h1 className="text-[16px] font-semibold">
                                Fill in your details.
                              </h1>
                            </div>

                            <Row className="">
                              <Col
                                md={24}
                                sm={24}
                                xs={24}
                                lg={24}
                                xl={24}
                                xxl={24}
                                className="package-fonts"
                              >
                                <Row className="mt-3">
                                  <Col
                                    md={5}
                                    sm={5}
                                    xs={5}
                                    lg={5}
                                    xl={5}
                                    xxl={5}
                                  >
                                    <div className="flex mt-1">
                                      <StarFilled />
                                      <h1 className="text-[13px] ml-3 package-fonts font-medium">
                                        Departure City
                                      </h1>
                                    </div>
                                  </Col>
                                  <Col
                                    md={19}
                                    sm={19}
                                    xs={19}
                                    lg={19}
                                    xl={19}
                                    xxl={19}
                                  >
                                    <Row>
                                      <Col
                                        md={8}
                                        sm={8}
                                        xs={8}
                                        lg={8}
                                        xl={8}
                                        xxl={8}
                                        className="pr-3"
                                      >
                                        <Select
                                          value={departureCity}
                                          onChange={(e, options) => {
                                            setDepartureCity({
                                              label: options.label,
                                              value: e,
                                            });
                                          }}
                                          showSearch
                                          optionFilterProp="label"
                                          filterOption={(input, option) =>
                                            (option?.label ?? "")
                                              .toLowerCase()
                                              .includes(input.toLowerCase())
                                          }
                                          options={destinationOptions}
                                          dropdownRender={(menu) => (
                                            <>
                                              <p className="bg-[#f1f1f1] p-1 rounded-md text-center input-label">
                                                Please Select
                                              </p>
                                              <Divider
                                                style={{
                                                  margin: "8px 0",
                                                }}
                                              />
                                              <p className="input-label">
                                                {" "}
                                                {menu}
                                              </p>
                                            </>
                                          )}
                                          className="input-label w-[100%] h-[35px]"
                                          placeholder="Select departure city"
                                          style={{
                                            fontFamily: "Poppins",
                                            fontWeight: 600,
                                            borderRadius: "6px",
                                            border: "1px solid #cfcfcfe0",
                                          }}
                                          variant={false}
                                        />
                                        <p
                                          style={{
                                            display: "inline-block",
                                          }}
                                          className="text-start input-label text-[#ff0000] mt-2 mb-1 text-[11px]"
                                        >
                                          {simpleValidator.current.message(
                                            "departureCity",
                                            departureCity &&
                                              departureCity.value,
                                            "required"
                                          )}
                                        </p>
                                      </Col>
                                      <Col
                                        md={8}
                                        sm={8}
                                        xs={8}
                                        lg={8}
                                        xl={8}
                                        xxl={8}
                                      >
                                        <Select
                                          value={tourTypeList}
                                          onChange={(e, options) =>
                                            setTourTypeList({
                                              label: options.label,
                                              value: e,
                                            })
                                          }
                                          options={
                                            availableFacilities &&
                                            availableFacilities.length > 0
                                              ? availableFacilities
                                              : recordsMetaData
                                              ? recordsMetaData.facilityTypeOptions
                                              : []
                                          }
                                          showSearch
                                          optionFilterProp="label"
                                          filterOption={(input, option) =>
                                            // console.log(option, "options")
                                            // console.log(input, "inputs")
                                            (option?.label ?? "")
                                              .toLowerCase()
                                              .includes(input.toLowerCase())
                                          }
                                          dropdownRender={(menu) => (
                                            <>
                                              <p className="bg-[#f1f1f1] p-1 rounded-md text-center input-label">
                                                Please Select
                                              </p>
                                              <Divider
                                                style={{
                                                  margin: "8px 0",
                                                }}
                                              />
                                              <p className="input-label">
                                                {" "}
                                                {menu}
                                              </p>
                                            </>
                                          )}
                                          className="input-label w-[100%] h-[35px]"
                                          placeholder="Select tour type"
                                          style={{
                                            fontFamily: "Poppins",
                                            fontWeight: 600,
                                            borderRadius: "6px",
                                            border: "1px solid #cfcfcfe0",
                                          }}
                                          variant={false}
                                        />
                                        <p
                                          style={{
                                            display: "inline-block",
                                          }}
                                          className="text-start input-label text-[#ff0000] mt-2 mb-1 text-[11px]"
                                        >
                                          {simpleValidator.current.message(
                                            "tourTypeList",
                                            tourTypeList && tourTypeList.value,
                                            "required"
                                          )}
                                        </p>
                                      </Col>
                                    </Row>
                                  </Col>
                                </Row>
                                <Row className="mt-5">
                                  <Col
                                    md={24}
                                    sm={24}
                                    xs={24}
                                    lg={24}
                                    xl={24}
                                    xxl={24}
                                  >
                                    <Row>
                                      <Col
                                        md={5}
                                        sm={5}
                                        xs={5}
                                        lg={5}
                                        xl={5}
                                        xxl={5}
                                      >
                                        <div className="flex mt-1">
                                          <UserOutlined />
                                          <h1 className="text-[13px] ml-3 package-fonts font-medium">
                                            Select Travellers
                                          </h1>
                                        </div>
                                      </Col>
                                      <Col
                                        md={19}
                                        sm={19}
                                        xs={19}
                                        lg={19}
                                        xl={19}
                                        xxl={19}
                                        className="flex flex-col"
                                      >
                                        <Divider
                                          style={{
                                            borderWidth: 0.2,
                                            marginTop: "10px",
                                          }}
                                        />
                                        {roomTypeList.length == 0 ? (
                                          <div
                                            className="w-[100%] cursor-pointer flex justify-end input-label font-semibold border w-[70px] borde-1 rounded-md p-1 text-[#eb3e43]"
                                            onClick={addRoomDetails}
                                          >
                                            <PlusOutlined className="text-[16px] mr-2" />{" "}
                                            ADD
                                          </div>
                                        ) : (
                                          ""
                                        )}
                                      </Col>
                                    </Row>
                                  </Col>
                                  <Col
                                    md={24}
                                    sm={24}
                                    xs={24}
                                    lg={24}
                                    xl={24}
                                    xxl={24}
                                  >
                                    {roomTypeList.map((data, index) => {
                                      data.label = "Room " + (index + 1);

                                      return (
                                        <Row key={index} className="mb-5">
                                          <Col
                                            md={5}
                                            sm={5}
                                            xs={5}
                                            lg={5}
                                            xl={5}
                                            xxl={5}
                                            className="pt-3 package-fonts text-center"
                                          >
                                            {data.label}
                                            <div
                                              onClick={() => addRoomDetails()}
                                              className="cursor-pointer text-[#eb3e43] underline"
                                            >
                                              + Add Room
                                            </div>
                                          </Col>
                                          <Col
                                            md={18}
                                            sm={18}
                                            xs={18}
                                            lg={18}
                                            xl={18}
                                            xxl={18}
                                            className="flex flex-row"
                                          >
                                            <Row
                                              className=""
                                              // gutter={[14, 14]}
                                              wrap
                                            >
                                              {data.roomTypes &&
                                                data.roomTypes.map(
                                                  (room, typeIndex) => {
                                                    const roomTypeId =
                                                      roomTypeList[index]
                                                        .roomTypes[typeIndex]
                                                        ._id; // Get _id from roomTypes
                                                    const matchedTravellerAgeId =
                                                      findMatchingTravellerAgeId(
                                                        roomTypeId
                                                      ); // Find matching travellerAgeId

                                                    return (
                                                      <Col
                                                        md={6}
                                                        sm={24}
                                                        xs={24}
                                                        lg={6}
                                                        xl={6}
                                                        xxl={6}
                                                        key={typeIndex}
                                                        className={
                                                          media == "sm" ||
                                                          media == "xs"
                                                            ? "pr-5 package-fonts"
                                                            : "pr-[40px] package-fonts"
                                                        }
                                                      >
                                                        <div
                                                          className={
                                                            media == "sm" ||
                                                            media == "xs"
                                                              ? "w-[100%]"
                                                              : "w-[135%]"
                                                          }
                                                        >
                                                          <div className="text-center w-[100%]">
                                                            <h1
                                                              style={{
                                                                display:
                                                                  "inline-block",
                                                                width:
                                                                  "max-content",
                                                              }}
                                                              className="text-[11px] font-semibold"
                                                            >
                                                              {room.typeName}
                                                            </h1>
                                                          </div>
                                                          <div className="w-[100%] flex mt-1 pl-3 pr-3 rounded-md border border-1 border-lightgray-500 bg-[#ffffff]">
                                                            <h1
                                                              onClick={() =>
                                                                handleCountChange(
                                                                  index,
                                                                  typeIndex,
                                                                  "decrement",
                                                                  matchedTravellerAgeId
                                                                )
                                                              }
                                                              style={{
                                                                pointerEvents:
                                                                  matchedTravellerAgeId ===
                                                                  room._id
                                                                    ? ""
                                                                    : "none",
                                                                opacity:
                                                                  matchedTravellerAgeId ===
                                                                  room._id
                                                                    ? ""
                                                                    : "3",
                                                                cursor:
                                                                  matchedTravellerAgeId ===
                                                                  room._id
                                                                    ? "pointer"
                                                                    : "not-allowed",
                                                                color:
                                                                  matchedTravellerAgeId ===
                                                                  room._id
                                                                    ? "#eb3e43"
                                                                    : "#ffcccd",
                                                              }}
                                                              className="text-[16px] font-semibold pt-1 pr-2 pl-1 border border-r-1 border-y-0 border-l-0 border-lightgray-500 purchase-label font-semibold"
                                                            >
                                                              -
                                                            </h1>
                                                            <h1 className="text-[14px] pt-1 pb-1 pr-4 pl-4">
                                                              {matchedTravellerAgeId !==
                                                              room._id
                                                                ? 0
                                                                : room.count}
                                                            </h1>
                                                            <h1
                                                              onClick={() =>
                                                                handleCountChange(
                                                                  index,
                                                                  typeIndex,
                                                                  "increment",
                                                                  matchedTravellerAgeId
                                                                )
                                                              }
                                                              style={{
                                                                pointerEvents:
                                                                  matchedTravellerAgeId ===
                                                                  room._id
                                                                    ? ""
                                                                    : "none",
                                                                opacity:
                                                                  matchedTravellerAgeId ===
                                                                  room._id
                                                                    ? ""
                                                                    : "3",
                                                                cursor:
                                                                  matchedTravellerAgeId ===
                                                                  room._id
                                                                    ? "pointer"
                                                                    : "not-allowed",
                                                                color:
                                                                  matchedTravellerAgeId ===
                                                                  room._id
                                                                    ? "#eb3e43"
                                                                    : "#ffcccd",
                                                              }}
                                                              className="text-[16px] text-[#eb3e43] font-semibold pt-1 pr-2 pl-2 border border-l-1 border-y-0 border-r-0 purchase-label font-semibold"
                                                            >
                                                              +
                                                            </h1>
                                                          </div>
                                                          <div className="text-center text-[11px] text-[#838080]">
                                                            ({room.age})
                                                          </div>
                                                        </div>
                                                      </Col>
                                                    );
                                                  }
                                                )}
                                            </Row>

                                            {/* {data.roomTypes.length > 0
                                              ? data.roomTypes.map(
                                                  (room, index) => {
                                                    return (
                                                      <Row
                                                        className="flex flex-row mb-2"
                                                        key={index}
                                                      >
                                                        <Col
                                                          md={24}
                                                          sm={24}
                                                          xs={24}
                                                          lg={24}
                                                          xl={24}
                                                          xxl={24}
                                                          className="pr-5 package-fonts"
                                                        >
                                                          <div className="w-[100%]">
                                                            <h1
                                                              style={{
                                                                display:
                                                                  "inline-block",
                                                                width:
                                                                  "max-content",
                                                              }}
                                                              className="text-center text-[11px] font-semibold"
                                                            >
                                                              {room.typeName}
                                                              <span className="text-[11px] font-medium">
                                                                {room.subType}
                                                              </span>
                                                            </h1>
                                                            <div className="w-[104%] flex mt-1 pl-3 pr-3 rounded-md border border-1 border-lightgray-500 bg-[#ffffff]">
                                                              <h1 className="cursor-pointer text-[16px] text-[#eb3e43] font-semibold pt-1 pr-2 pl-1 border border-r-1 border-y-0 border-l-0 border-lightgray-500 purchase-label font-semibold">
                                                                -
                                                              </h1>
                                                              <h1 className="text-[14px] pt-1 pb-1 pr-4 pl-4">
                                                                {room.count}
                                                              </h1>
                                                              <h1 className="cursor-pointer text-[16px] text-[#eb3e43] font-semibold pt-1 pr-2 pl-2 border border-l-1 border-y-0 border-r-0 purchase-label font-semibold">
                                                                +
                                                              </h1>
                                                            </div>
                                                            <div className="text-center text-[11px] text-[#838080]">
                                                              ({room.age})
                                                            </div>
                                                          </div>
                                                        </Col>
                                                      </Row>
                                                    );
                                                  }
                                                )
                                              : ""} */}
                                          </Col>
                                          <Col
                                            md={1}
                                            sm={1}
                                            xs={1}
                                            lg={1}
                                            xl={1}
                                            xxl={1}
                                            className="flex flex-row pl-3"
                                          >
                                            <CloseCircleOutlined
                                              onClick={() =>
                                                removeRoomTypes(index)
                                              }
                                              className="text-[18px] text-[#eb3e43]"
                                            />
                                          </Col>
                                        </Row>
                                      );
                                    })}
                                    <Row>
                                      <Col
                                        md={5}
                                        sm={5}
                                        xs={5}
                                        lg={5}
                                        xl={5}
                                        xxl={5}
                                        className="pt-3 package-fonts text-center"
                                      ></Col>
                                      <Col
                                        md={19}
                                        sm={19}
                                        xs={19}
                                        lg={19}
                                        xl={19}
                                        xxl={19}
                                        className="flex flex-row"
                                      >
                                        <Divider
                                          style={{
                                            borderWidth: 0.2,
                                            marginTop: "16px",
                                          }}
                                        />
                                      </Col>
                                    </Row>
                                  </Col>
                                </Row>
                                <Row className="mt-5">
                                  <Col
                                    md={5}
                                    sm={5}
                                    xs={5}
                                    lg={5}
                                    xl={5}
                                    xxl={5}
                                  >
                                    <div className="flex mt-1">
                                      <CalendarOutlined />
                                      <h1 className="text-[13px] ml-3 package-fonts font-medium">
                                        Date of Travel
                                      </h1>
                                    </div>
                                  </Col>
                                  <Col
                                    md={19}
                                    sm={19}
                                    xs={19}
                                    lg={19}
                                    xl={19}
                                    xxl={19}
                                  >
                                    <Row>
                                      <Col
                                        md={8}
                                        sm={8}
                                        xs={8}
                                        lg={8}
                                        xl={8}
                                        xxl={8}
                                      >
                                        <DatePicker
                                          className="w-[100%] h-[35px]"
                                          placeholder="Travel Date"
                                          variant={false}
                                          placement="bottom left"
                                          format="Do MMMM YYYY"
                                          popupClassName="min-h-[30%]"
                                          // value={asOfDate}
                                          onChange={(date, dateString, id) => {
                                            if (dateString) {
                                              setTravelDate(dateString);
                                            } else {
                                              setTravelDate("");
                                            }
                                          }}
                                          style={{
                                            fontFamily: "Poppins",
                                            fontWeight: 600,
                                            borderRadius: "6px",
                                            border: "1px solid #cfcfcfe0",
                                          }}
                                        />
                                        <p
                                          style={{
                                            display: "inline-block",
                                          }}
                                          className="text-start input-label text-[#ff0000] mt-2 mb-1 text-[11px]"
                                        >
                                          {simpleValidator.current.message(
                                            "travelDate",
                                            travelDate,
                                            "required"
                                          )}
                                        </p>
                                      </Col>
                                    </Row>
                                  </Col>
                                </Row>
                                <Row className="mt-5">
                                  <Col
                                    md={5}
                                    sm={5}
                                    xs={5}
                                    lg={5}
                                    xl={5}
                                    xxl={5}
                                  >
                                    <div className="flex mt-1">
                                      <FaPhoneAlt />
                                      <h1 className="text-[13px] ml-3 package-fonts font-medium">
                                        Your Contact Details
                                      </h1>
                                    </div>
                                  </Col>
                                  <Col
                                    md={19}
                                    sm={19}
                                    xs={19}
                                    lg={19}
                                    xl={19}
                                    xxl={19}
                                  >
                                    <Row>
                                      <Col
                                        md={8}
                                        sm={8}
                                        xs={8}
                                        lg={8}
                                        xl={8}
                                        xxl={8}
                                        className=""
                                      >
                                        <Input
                                          className="w-[100%] h-[35px]"
                                          name="mobile"
                                          value={mobile}
                                          onChange={validationChange}
                                          placeholder="Mobile"
                                          id="main-input"
                                          maxLength={10}
                                          prefix={"+91"}
                                          style={{
                                            fontFamily: "Poppins",
                                            fontWeight: 600,
                                            borderRadius: "6px",
                                            border: "1px solid #cfcfcfe0",
                                          }}
                                          variant={false}
                                        />
                                        <div
                                          id="error-panel"
                                          style={{
                                            // display: "none",
                                            // marginTop: "-15px",
                                            marginBottom: "10px",
                                          }}
                                        >
                                          {mobileValidations == true ? (
                                            <p className="input-label text-[11px] text-start text-[#ff0000]">
                                              The mobile field is not valid
                                            </p>
                                          ) : (
                                            <p
                                              style={{
                                                display: "inline-block",
                                              }}
                                              className="text-start input-label text-[#ff0000] mt-2 mb-1 text-[11px]"
                                            >
                                              {simpleValidator.current.message(
                                                "mobile",
                                                mobile,
                                                "required"
                                              )}
                                            </p>
                                          )}
                                        </div>
                                      </Col>
                                      <Col
                                        md={8}
                                        sm={8}
                                        xs={8}
                                        lg={8}
                                        xl={8}
                                        xxl={8}
                                        className="pl-3"
                                      >
                                        <Input
                                          className="w-[100%] h-[35px]"
                                          name="email"
                                          value={email}
                                          onChange={validationEmailChange}
                                          placeholder="Email"
                                          id="main-email-input"
                                          style={{
                                            fontFamily: "Poppins",
                                            fontWeight: 600,
                                            borderRadius: "6px",
                                            border: "1px solid #cfcfcfe0",
                                          }}
                                          variant={false}
                                        />
                                        <div
                                          id="error-email-panel"
                                          style={{
                                            // display: "none",
                                            // marginTop: "-15px",
                                            marginBottom: "10px",
                                          }}
                                        >
                                          {emailValidations == true ? (
                                            <p className="input-label text-[11px] text-start text-[#ff0000]">
                                              The email field is not valid
                                            </p>
                                          ) : (
                                            <p
                                              style={{
                                                display: "inline-block",
                                              }}
                                              className="text-start input-label text-[#ff0000] mt-2 mb-1 text-[11px]"
                                            >
                                              {simpleValidator.current.message(
                                                "email",
                                                email,
                                                "required"
                                              )}
                                            </p>
                                          )}
                                        </div>
                                      </Col>
                                    </Row>
                                    <Row>
                                      <Col
                                        md={24}
                                        sm={24}
                                        xs={24}
                                        lg={24}
                                        xl={24}
                                        xxl={24}
                                        className=""
                                      >
                                        <div className="w-[100%]">
                                          <h1 className="package-fonts mt-1">
                                            Your booking details will be sent on
                                            these contact details
                                          </h1>
                                          <div className="flex package-fonts mt-1 mb-2">
                                            <Checkbox
                                              checked={policyAccept}
                                              onChange={(e) =>
                                                setPolicyAccept(
                                                  e.target.checked
                                                )
                                              }
                                              className="hover:text-[#eb3e43] hover:border-[#eb3e43]"
                                            />
                                            <p className="text-[13px] ml-1 mr-1">
                                              I accept the{" "}
                                              <span className="underline text-[#eb3e43] mr-2">
                                                {" "}
                                                Privacy Policy
                                              </span>{" "}
                                              &{" "}
                                              <span className="underline text-[#eb3e43] mr-2">
                                                Terms & Conditions
                                              </span>
                                            </p>
                                          </div>
                                          <div
                                            className="w-[60%] text-[16px] text-center leading-loose track-wider mt-3 mb-2"
                                            style={{
                                              borderRadius: "40px",
                                              // border: "1px",
                                              // padding: "4px 20px",
                                              fontFamily: "Poppins",
                                              background: "#eb3e43",
                                              padding: "4px 22px",
                                              color: "white",
                                              pointerEvents: buttonDisabled
                                                ? "none"
                                                : "",
                                              opacity: buttonDisabled ? 1 : "",
                                              cursor: buttonDisabled
                                                ? "not-allowed"
                                                : "pointer",
                                            }}
                                            onClick={() =>
                                              calculatePriceDetails()
                                            }
                                          >
                                            <h1 className="">
                                              Calculate Package Price
                                            </h1>
                                          </div>
                                        </div>
                                      </Col>
                                    </Row>
                                  </Col>
                                </Row>
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                      </Col>
                    ) : packageTabDetails === "Terms & Conditions" ? (
                      <Col
                        md={24}
                        sm={24}
                        xs={24}
                        lg={24}
                        xl={24}
                        xxl={24}
                        className="package-fonts mt-3"
                      >
                        <div className="w-[100%] bg-[white] border border-1 rounded-xl shadow-md p-2 mt-3 pb-2">
                          <div className="w-[100%] flex pb-1">
                            <p className="w-[4px] bg-[#eb3e43] h-[20px] mr-2 ml-[-8px]"></p>
                            <h1 className="text-[16px] font-semibold">
                              Terms & Conditions
                            </h1>
                          </div>
                          <Row>
                            {termsConditionsList &&
                            termsConditionsList.length > 0
                              ? termsConditionsList.map((data) => {
                                  return (
                                    <Col
                                      md={24}
                                      sm={24}
                                      xs={24}
                                      lg={24}
                                      xl={24}
                                      xxl={24}
                                      className="mt-2 package-fonts rounded-lg border border-1 mb-2"
                                    >
                                      <div className="bg-[#ff4c518a] rounded-tr-lg rounded-tl-lg font-semibold p-2">
                                        {data.categoryName}
                                      </div>
                                      <div className="pt-2 pb-3">
                                        {data.terms.map((terms, index) => {
                                          return (
                                            <ul
                                              key={index}
                                              style={{
                                                listStyleType: "initial",
                                                listStyle: "inside",
                                                padding: "2px 16px",
                                              }}
                                              dangerouslySetInnerHTML={{
                                                __html: terms.termsName
                                                  ? terms.termsName
                                                  : "",
                                              }}
                                            >
                                              {/* <li className="text-[13.5px]">
                                                {terms.termsName}
                                              </li> */}
                                            </ul>
                                          );
                                        })}
                                      </div>
                                    </Col>
                                  );
                                })
                              : "No Terms Found"}
                          </Row>
                        </div>
                      </Col>
                    ) : (
                      <Col md={24} sm={24} xs={24} lg={24} xl={24} xxl={24}>
                        <Row>
                          <Col
                            md={24}
                            sm={24}
                            xs={24}
                            lg={24}
                            xl={24}
                            xxl={24}
                            className="flex flex-row bg-[white] border border-1 rounded-xl shadow-lg p-2 mt-3"
                            style={{
                              fontFamily: "Poppins",
                            }}
                            id="overview"
                          >
                            <div className="pb-2">
                              <div className="flex">
                                <p className="w-[4px] bg-[#eb3e43] h-[20px] mr-2 ml-[-8px]"></p>
                                <h1 className="text-[16px] font-semibold">
                                  Package Overview
                                </h1>
                              </div>
                              <div
                                // id="output"
                                className="text-[12px] mt-2 ml-1"
                                dangerouslySetInnerHTML={{
                                  __html: packageDetailsData
                                    ? packageDetailsData.packageDescription
                                    : "",
                                }} // Render HTML safely
                              ></div>
                              {/* <p >
                                {packageDetailsData
                                  ? packageDetailsData.packageDescription
                                  : ""}
                              </p> */}
                            </div>
                          </Col>
                          <Col
                            md={24}
                            sm={24}
                            xs={24}
                            lg={24}
                            xl={24}
                            xxl={24}
                            className="package-fonts mt-3"
                          >
                            <div className="w-[100%] h-[100%] bg-[white] border border-1 rounded-xl shadow-md p-2 mt-3 pb-2">
                              <div className="w-[100%] flex pb-1">
                                <p className="w-[4px] bg-[#eb3e43] h-[20px] mr-2 ml-[-8px]"></p>
                                <h1 className="text-[16px] font-semibold">
                                  {/* <FaHotel className="mt-[2px] text-[#eb3e43] mr-2" />{" "} */}
                                  Accommodations
                                </h1>
                              </div>
                              <div className="w-[100%] flex pb-1 mt-2">
                                <h1 className="text-[13px] font-normal">
                                  The accommodation changes according to Tour
                                  type. Please select the tour type.
                                </h1>
                              </div>
                              <Row className="mt-2 mb-5">
                                <Col
                                  md={24}
                                  sm={24}
                                  xs={24}
                                  lg={24}
                                  xl={24}
                                  xxl={24}
                                  className="h-[100%]"
                                >
                                  <Row>
                                    <Col
                                      md={10}
                                      sm={24}
                                      xs={24}
                                      lg={10}
                                      xl={10}
                                      xxl={10}
                                    >
                                      <Select
                                        value={accomodationsList}
                                        onChange={(e, options) => {
                                          setAccomodationsList({
                                            label: options.label,
                                            value: e,
                                          });
                                          setTourTypeList({
                                            label: options.label,
                                            value: e,
                                          });
                                          setAccomodationsChanges(true);
                                          // if (e) {
                                          dispatch(
                                            loadPackageSingleList(
                                              packageDetailsDataId +
                                                `?facilityId=${e}`
                                            )
                                          );
                                          // }
                                        }}
                                        name="accomodationsList"
                                        options={
                                          availableFacilities &&
                                          availableFacilities.length > 0
                                            ? availableFacilities
                                            : recordsMetaData
                                            ? recordsMetaData.facilityTypeOptions
                                            : []
                                        }
                                        dropdownRender={(menu) => (
                                          <>
                                            <p className="bg-[#f1f1f1] p-1 rounded-md text-center input-label">
                                              Please Select
                                            </p>
                                            <Divider
                                              style={{
                                                margin: "8px 0",
                                              }}
                                            />
                                            <p className="input-label">
                                              {" "}
                                              {menu}
                                            </p>
                                          </>
                                        )}
                                        showSearch
                                        optionFilterProp="label"
                                        filterOption={(input, option) =>
                                          // console.log(option, "options")
                                          // console.log(input, "inputs")
                                          (option?.label ?? "")
                                            .toLowerCase()
                                            .includes(input.toLowerCase())
                                        }
                                        className="input-label w-[100%] h-[35px]"
                                        placeholder="Select tour type"
                                        style={{
                                          fontFamily: "Poppins",
                                          fontWeight: 600,
                                          borderRadius: "0px",
                                          border: "1px solid #cfcfcfe0",
                                        }}
                                        variant={false}
                                      />
                                    </Col>
                                    <Col
                                      md={24}
                                      sm={24}
                                      xs={24}
                                      lg={24}
                                      xl={24}
                                      xxl={24}
                                      className="h-[100%]"
                                    >
                                      {/* {packageDataTable && packageDataTable.overAllHotels && packageDataTable.overAllHotels.length > 0 ? (
                                        <Slider
                                          {...settings}
                                          centerMode
                                          className="w-[100%] pr-3 pl-3"
                                        > */}
                                      {/* <Slider {...settings} centerMode className="h-[280px]"> */}
                                      {packageDataTable &&
                                      packageDataTable.overAllHotels &&
                                      packageDataTable.overAllHotels.length >
                                        0 ? (
                                        packageDataTable.overAllHotels.map(
                                          (slide, index) => {
                                            const imageUrl =
                                              slide && slide.images.length > 0
                                                ? slide.images[0]
                                                : "";

                                            return (
                                              <Row
                                                key={index}
                                                className="h-[100%] pt-4 pb-5"
                                              >
                                                <Col
                                                  md={10}
                                                  sm={24}
                                                  xs={24}
                                                  lg={10}
                                                  xl={10}
                                                  xxl={10}
                                                  className=""
                                                >
                                                  <Image
                                                    preview={false}
                                                    alt="no-img"
                                                    src={imageUrl}
                                                    width={"100%"}
                                                    className="border border-solid rounded-md"
                                                    height={200}
                                                  />
                                                </Col>
                                                <Col
                                                  md={14}
                                                  sm={24}
                                                  xs={24}
                                                  lg={14}
                                                  xl={14}
                                                  xxl={14}
                                                  className="pl-4"
                                                >
                                                  <Row>
                                                    <Col
                                                      md={24}
                                                      sm={24}
                                                      xs={24}
                                                      lg={24}
                                                      xl={24}
                                                      xxl={24}
                                                    >
                                                      <div className="flex w-[100%] input-label text-[13px]">
                                                        <h1 className="font-semibold">
                                                          {slide.destinationName +
                                                            "-" +
                                                            slide.hotelName}
                                                        </h1>
                                                        {/* <p className="ml-2 mr-2">
                                                          {"|"}
                                                        </p>
                                                        <p className="">
                                                          {slide.ratings}
                                                        </p> */}
                                                      </div>
                                                    </Col>
                                                    <Col
                                                      md={24}
                                                      sm={24}
                                                      xs={24}
                                                      lg={24}
                                                      xl={24}
                                                      xxl={24}
                                                      className="flex"
                                                    >
                                                      <div className="flex input-label text-[13px] mr-4">
                                                        <p className="">
                                                          <StarRating
                                                            rating={
                                                              slide.ratings
                                                            }
                                                          />
                                                        </p>
                                                      </div>
                                                      <div className="mt-2 flex input-label text-[13px]">
                                                        <p className="mr-2">
                                                          |
                                                        </p>

                                                        <p
                                                          className=""
                                                          dangerouslySetInnerHTML={{
                                                            __html:
                                                              slide.address
                                                                ? slide.address
                                                                : "",
                                                          }}
                                                        ></p>
                                                      </div>
                                                    </Col>
                                                  </Row>
                                                </Col>
                                              </Row>
                                            );
                                          }
                                        )
                                      ) : (
                                        <div className="text-center images-label">
                                          No Images found
                                        </div>
                                      )}
                                      {/* </Slider> */}
                                      {/* ) : (
                                        <div className="text-center images-label">
                                          No Images found
                                        </div>
                                      )} */}
                                    </Col>
                                  </Row>
                                </Col>
                              </Row>
                            </div>
                          </Col>
                          <Col
                            md={24}
                            sm={24}
                            xs={24}
                            lg={24}
                            xl={24}
                            xxl={24}
                            className="package-fonts mt-3"
                          >
                            <div className="w-[100%] bg-[white] border border-1 rounded-xl shadow-md p-2 mt-3 pb-2">
                              <div className="w-[100%] flex pb-1">
                                <p className="w-[4px] bg-[#eb3e43] h-[20px] mr-2 ml-[-8px]"></p>
                                <h1 className="text-[16px] font-semibold">
                                  {/* <GiHotMeal className="mt-[2px] text-[#eb3e43] mr-2" />{" "} */}
                                  Meals
                                </h1>
                              </div>
                              <div className="w-[100%] flex mt-5 mb-5 pr-6">
                                <h1 className="w-[80%] text-[13px] flex font-normal pr-6 pl-2">
                                  {packageDataTable &&
                                  packageDataTable.meals &&
                                  packageDataTable.meals ? (
                                    <div className="flex">
                                      <FaCaretRight className="mt-1 text-[#eb3e43] mr-1" />{" "}
                                      <h1
                                        dangerouslySetInnerHTML={{
                                          __html:
                                            packageDataTable.meals &&
                                            packageDataTable.meals,
                                        }}
                                        className="text-[13px] font-normal"
                                      >
                                        {/* {packageDataTable.meals} */}
                                      </h1>
                                    </div>
                                  ) : (
                                    ""
                                  )}
                                </h1>
                              </div>
                            </div>
                          </Col>
                        </Row>
                      </Col>
                    )}
                  </Row>
                </Col>
                <Col
                  md={24}
                  sm={24}
                  xs={24}
                  lg={7}
                  xl={7}
                  xxl={7}
                  className={
                    media == "md" || media == "sm" || media == "xs"
                      ? "mt-4"
                      : media == "xxl" && hideTop === true
                      ? `pl-6 sticky-box ${
                          isFixed ? "sticky-extra-large-fixed-and-hide-top" : ""
                        }`
                      : media == "xxl" && hideTop === false
                      ? `pl-6 sticky-box ${
                          isFixed ? "sticky-extra-large-fixed" : ""
                        }`
                      : media == "lg" && hideTop === true
                      ? `pl-6 sticky-box ${
                          isFixed
                            ? "sticky-medium-package-extra-fixed-and-hide-top"
                            : ""
                        }`
                      : media == "lg" && hideTop === false
                      ? `pl-6 sticky-box ${
                          isFixed ? "sticky-medium-package-extra-fixed" : ""
                        }`
                      : media == "xl" && hideTop === true
                      ? `pl-6 sticky-box ${
                          isFixed ? "sticky-fixed-and-hide-top" : ""
                        }`
                      : `pl-6 sticky-box ${isFixed ? "sticky-fixed" : ""}`
                  }
                  ref={componentRef}
                >
                  <Row className="">
                    <Col
                      md={24}
                      sm={24}
                      xs={24}
                      lg={24}
                      xl={24}
                      xxl={24}
                      className="border shadow-md bg-[white] border-1 rounded-xl"
                    >
                      <div
                        style={{
                          fontFamily: "Poppins",
                        }}
                        className="bg-[#eb3e432e] rounded-t-xl rounded-b-xs"
                      >
                        <div className="flex w-[100%] pl-3 pt-1 pb-1">
                          <div>
                            <h1 className="text-[12px]">Starting from</h1>
                            <p
                              style={{
                                textDecorationLine: "line-through",
                              }}
                              className="text-[16px] font-semibold"
                            >
                              {calculatedPrice &&
                              calculatedPrice.startingFrom !== ""
                                ? "₹ " + calculatedPrice.startingFrom
                                : packageDataTable &&
                                  packageDataTable.startingFrom !== ""
                                ? packageDetailsData.startingFrom
                                : ""}
                            </p>
                          </div>
                        </div>
                        <div className="flex w-[100%] pl-3">
                          <div className="">
                            <h1 className="text-[20px] text-[black] font-extrabold">
                              {calculatedPrice && calculatedPrice.price !== ""
                                ? "₹ " + calculatedPrice.price
                                : packageDataTable &&
                                  packageDataTable.lowestPrice !== "" &&
                                  packageDataTable.lowestPrice !== undefined &&
                                  packageDataTable.lowestPrice !== null
                                ? "₹ " + packageDataTable.lowestPrice
                                : "₹ 0"}
                            </h1>
                          </div>
                          <div className="pl-2 mt-[6px]">
                            <p className="text-[11px] font-semibold">
                              Per Person
                            </p>
                          </div>
                        </div>
                        <div className="mt-3 flex justify-between text-[12px] p-3">
                          {/* <div className="mt-3 flex justify-between lg:justify-between xl:justify-between xxl:justify-between md:justify-between text-[12px] p-3"> */}
                          <h1
                            onClick={() => handleDownload()}
                            className="flex cursor-pointer text-[#eb3a3e] font-semibold text-[13px] images-label"
                          >
                            {shareLoading ? (
                              <p className="flex">
                                <Spin className="mr-1" /> Downloading
                              </p>
                            ) : (
                              <p className="flex">
                                <DownloadOutlined className="mr-1" /> Download
                                PDF
                              </p>
                            )}
                          </h1>
                          <h1
                            onClick={() => {
                              handleSharePDF();
                              setShareModal(true);
                              setReceiverDetails([]);
                              setSenderEmail("");
                              setSenderName("");
                              setReceiverName("");
                              setReceiverEmail("");
                            }}
                            className="flex cursor-pointer images-label font-semibold text-[13px]"
                          >
                            <ShareAltOutlined className="mr-1" /> Share
                          </h1>
                        </div>
                        <TourPDFContent
                          ref={pdfComponentRef}
                          data={packageDataTable}
                          id={"share-pdf"}
                          packageDetailsData={packageDetailsData}
                        />
                        {/* <div className="flex text-[12px] p-3">
                          <h1>No Cost Emi Starts from</h1>
                          <h1 className="mr-1 ml-1">
                            {!isEmpty(packageDetailsData)
                              ? packageDetailsData.EMIFrom
                              : ""}
                          </h1>
                          <h1 className="text-[#eb3a3e] text-[12px] ml-2">
                            See option
                          </h1>
                        </div> */}
                      </div>
                      <div className="w-[100%] pt-2 pb-2 pl-2 pr-2">
                        <div
                          className="cursor-pointer hover:bg-[red] text-center uppercase text-[12px] leading-loose track-wider ml-5 mt-1 mr-4"
                          style={{
                            borderRadius: "25px",
                            // border: "1px",
                            // padding: "4px 20px",
                            fontFamily: "Poppins",
                            background: "#eb3e43",
                            padding: "4px 22px",
                            color: "white",
                            pointerEvents: bookingButtonDisabled ? "none" : "",
                            opacity: bookingButtonDisabled ? "1" : "",
                            // cursor: bookingButtonDisabled
                            //   ? "not-allowed"
                            //   : "pointer",
                          }}
                          onClick={() => {
                            setPackageTabDetails("Calculate Price");
                            addBooking();
                          }}
                        >
                          <h1 className="">
                            {bookingButtonDisabled ? (
                              <p className="flex justify-center">
                                <Spin className="ml-1 text-[white]" />
                                {"Processing..."}
                              </p>
                            ) : (
                              "Book Now"
                            )}
                          </h1>
                        </div>
                        <div
                          className="mt-1 text-center uppercase text-[12px] leading-loose track-wider ml-5 mt-1 mr-4"
                          style={{
                            borderRadius: "25px",
                            border: "1px solid #eb3e43",
                            // padding: "4px 20px",
                            fontFamily: "Poppins",
                            background: "#ffffff",
                            padding: "4px 22px",
                            color: "#eb3e43",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            addEquireForm();
                          }}
                        >
                          {enquireLoading ? (
                            <Spin />
                          ) : (
                            <h1 className="">Enquire Now</h1>
                          )}
                        </div>
                      </div>
                    </Col>
                    <Col
                      md={24}
                      sm={24}
                      xs={24}
                      lg={24}
                      xl={24}
                      xxl={24}
                      className="border bg-[white] shadow-md border-1 rounded-xl mt-4 p-1"
                    >
                      <Row>
                        <Col md={24} sm={24} xs={24} lg={24} xl={24} xxl={24}>
                          <div
                            style={{
                              fontFamily: "Poppins",
                            }}
                            className="flex w-[100%] pl-3 pt-1 pb-1"
                          >
                            <div className="flex">
                              <FcClock className="mt-[2px] mr-1" />
                              <h1 className="text-[12px] font-semibold">
                                Duration:
                              </h1>
                            </div>
                            <p className="ml-3 package-fonts text-[11px] font-medium">
                              {" "}
                              {packageDataTable &&
                              packageDataTable.totalDayAndNight
                                ? packageDataTable.totalDayAndNight
                                : !isEmpty(packageDetailsData)
                                ? packageDetailsData.nights +
                                  " / " +
                                  packageDetailsData.days
                                : ""}
                            </p>
                          </div>
                        </Col>
                        <Col md={24} sm={24} xs={24} lg={24} xl={24} xxl={24}>
                          <div
                            style={{
                              fontFamily: "Poppins",
                            }}
                            className="w-[100%] pl-3 pt-1 pb-1"
                          >
                            <div className="flex">
                              <FaLocationDot className="mt-[2px] mr-1 text-[#eb3e43]" />
                              <h1 className="text-[12px] font-semibold">
                                Places to Visit:
                              </h1>
                            </div>
                            <div className="package-fonts text-[12px] mt-1 font-medium">
                              {!isEmpty(packageDetailsData)
                                ? packageDetailsData.Duration
                                : ""}
                            </div>
                          </div>
                        </Col>
                        <Col
                          md={24}
                          sm={24}
                          xs={24}
                          lg={24}
                          xl={24}
                          xxl={24}
                          className="bg-[white] mt-[-8px]"
                        >
                          <div
                            style={{
                              fontFamily: "Poppins",
                            }}
                            className="w-[100%] pl-3 pt-1 pb-1"
                          >
                            <div className="w-[100%]">
                              <Divider
                                style={{
                                  width: "107%",
                                  borderWidth: 0.1,
                                  marginLeft: "-16px",
                                }}
                              />
                              <div className="flex justify-center">
                                <div
                                  className="text-center text-[12px] leading-loose track-wider ml-5 mt-[-40px] mr-4"
                                  style={{
                                    borderRadius: "25px",
                                    // border: "1px",
                                    height: "28px",
                                    fontFamily: "Poppins",
                                    background: "#ededed",
                                    padding: "2px 10px",
                                    color: "black",
                                    cursor: "pointer",
                                  }}
                                >
                                  <h1 className="">Packages Included</h1>
                                </div>
                              </div>
                            </div>
                            <div
                              className={
                                "flex w-[100%] pl-3 pb-6 border-x-0 border-t-0"
                              }
                            >
                              {packageDetailsData.hotels === true ? (
                                <div className="pr-4">
                                  <FaHotel className="text-center text-[26px] w-[100%]" />
                                  <p className="text-start mt-1 text-[12px]">
                                    {"Hotel"}
                                  </p>
                                </div>
                              ) : (
                                ""
                              )}
                              {packageDetailsData.sightSeeing === true ? (
                                <div className="pr-4">
                                  <PiBinocularsBold className="text-center text-[26px] w-[100%]" />
                                  <p className="text-start mt-1 text-[12px]">
                                    {"Sightseeing"}
                                  </p>
                                </div>
                              ) : (
                                ""
                              )}
                              {packageDetailsData.transport === true ? (
                                <div className="pr-4">
                                  <IoCarSportSharp className="text-center text-[26px] w-[100%]" />
                                  <p className="text-start mt-1 text-[12px]">
                                    {"Transfer"}
                                  </p>
                                </div>
                              ) : (
                                ""
                              )}
                              {packageDetailsData.meals === true ? (
                                <div className="pr-4">
                                  <GiHotMeal className="text-center text-[26px] w-[100%]" />
                                  <p className="text-start mt-1 text-[12px]">
                                    {"Meal"}
                                  </p>
                                </div>
                              ) : (
                                ""
                              )}
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </Col>
                    <Col
                      md={24}
                      sm={24}
                      xs={24}
                      lg={24}
                      xl={24}
                      xxl={24}
                      className="border bg-[#ededed] shadow-sm border-1 rounded-xl mt-4 p-1"
                    >
                      <Row>
                        <Col md={24} sm={24} xs={24} lg={24} xl={24} xxl={24}>
                          <div
                            style={{
                              fontFamily: "Poppins",
                            }}
                            className="flex w-[100%] pl-1 pt-1 pb-1"
                          >
                            <div>
                              <FcOnlineSupport
                                size={35}
                                className="mt-[2px] mr-1"
                              />
                            </div>
                            <div className="mt-[2px]">
                              <p className="package-fonts text-[14px] font-semibold">
                                Need Help?
                              </p>
                              <p className="package-fonts text-[12px] font-medium">
                                <strong>Call us:</strong> 044-47654565
                              </p>
                              <p className="package-fonts text-[12px] font-medium">
                                <strong>Mail us: </strong>
                                holidays@planmitrip.com
                              </p>
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Col>
          </Row>
          {/* Enquire modal */}
          <Modal
            open={enquireModal}
            // title="Want to Go For A Memorable Holiday?"
            maskClosable={false}
            onClose={() => setEnquireModal(false)}
            closable
            onCancel={() => setEnquireModal(false)}
            footer={null}
            className="package-fonts p-3 mt-[-80px]"
            closeIcon
            width={620}
          >
            <Col md={24} sm={24} lg={24} xl={24} xxl={24}>
              <Row>
                <Col
                  md={24}
                  sm={24}
                  lg={24}
                  xl={24}
                  xxl={24}
                  className="package-fonts text-[20px] font-semibold"
                >
                  Want to Go For A Memorable Holiday?
                </Col>
              </Row>
              <Row>
                <Col md={24} sm={24} lg={24} xl={24} xxl={24} className="mt-3">
                  <Typography className="package-fonts mb-2">
                    Package Name
                  </Typography>
                  <Input
                    name="packageName"
                    value={packageName}
                    // disabled
                    style={{
                      height: "40px",
                      fontFamily: "Poppins",
                      paddingLeft: "8px",
                      pointerEvents: "none",
                      opacity: 1,
                    }}
                    className="text-[14px] package-fonts"
                    suffix={
                      <FaLocationDot className="text-[14px] mr-2 text-[#818181]" />
                    }
                  />
                </Col>
                <Col
                  md={24}
                  sm={24}
                  lg={24}
                  xl={24}
                  xxl={24}
                  className="flex mt-4"
                >
                  <h1
                    style={{
                      fontFamily: "Poppins",
                    }}
                    className="text-[16px] font-semibold"
                  >
                    Personal Details
                  </h1>
                  <p className="mt-3 ml-3 h-[1px] bg-[#ffa096] w-[70%]"></p>
                </Col>
                <Col
                  xs={24}
                  sm={24}
                  md={12}
                  lg={12}
                  xl={12}
                  xxl={12}
                  className="mt-2"
                >
                  <Typography className="package-fonts text-[14px] mb-2">
                    Name
                  </Typography>
                  <Input
                    name="customerName"
                    value={customerName}
                    style={{
                      height: "40px",
                      fontFamily: "Poppins",
                    }}
                    onChange={(e) => setCustomerName(e.target.value)}
                    placeholder="Your Name"
                    className="text-[14px] package-fonts"
                    suffix={<FaUser className="text-[14px] text-[#818181]" />}
                  />
                  <p
                    style={{
                      display: "inline-block",
                    }}
                    className="text-start input-label text-[#ff0000] mt-2 text-[11px]"
                  >
                    {enquireValidations === true && customerName === ""
                      ? "The name field is required"
                      : ""}
                  </p>
                </Col>
                <Col
                  xs={24}
                  sm={24}
                  md={12}
                  lg={12}
                  xl={12}
                  xxl={12}
                  className="mt-2 pl-3"
                >
                  <Typography className="package-fonts text-[14px] mb-2">
                    Mobile
                  </Typography>
                  <Input
                    name="customerMobile"
                    value={customerMobile}
                    id="main-enquire-input"
                    onChange={validationEnquireChange}
                    style={{
                      height: "40px",
                      fontFamily: "Poppins",
                    }}
                    maxLength={10}
                    placeholder="Your Mobile"
                    className="package-fonts text-[14px]"
                    suffix={<FaMobile className="text-[14px] text-[#818181]" />}
                  />
                  <div id="error-enquire-panel">
                    {customerMobileValidations == true ? (
                      <p className="input-label text-[11px] text-start text-[#ff0000]">
                        The mobile field is not valid
                      </p>
                    ) : (
                      <p
                        style={{
                          display: "inline-block",
                        }}
                        className="text-start input-label text-[#ff0000] mt-2 mb-1 text-[11px]"
                      >
                        {enquireValidations === true && customerMobile === ""
                          ? "The mobile field is required"
                          : ""}
                      </p>
                    )}
                  </div>
                </Col>
                <Col
                  xs={24}
                  sm={24}
                  md={24}
                  lg={24}
                  xl={24}
                  xxl={24}
                  className="mt-2"
                >
                  <Typography className="package-fonts text-[14px] mb-2">
                    Email ID
                  </Typography>
                  <Input
                    name="customerMail"
                    value={customerMail}
                    style={{
                      height: "40px",
                      fontFamily: "Poppins",
                    }}
                    onChange={validationEnquireEmailChange}
                    placeholder="Your Email ID"
                    id="main-enquire-email-input"
                    className="package-fonts text-[14px]"
                    suffix={
                      <MailFilled className="text-[14px] text-[#818181]" />
                    }
                  />
                  <div id="error-enquire-email-panel">
                    {customerEmailValidations == true ? (
                      <p className="input-label text-[11px] text-start text-[#ff0000]">
                        The email field is not valid
                      </p>
                    ) : (
                      <p
                        style={{
                          display: "inline-block",
                        }}
                        className="text-start input-label text-[#ff0000] mt-2 mb-1 text-[11px]"
                      >
                        {enquireValidations === true && customerMail === ""
                          ? "The mail field is required"
                          : ""}
                      </p>
                    )}
                  </div>
                </Col>
                <Col
                  xs={24}
                  sm={24}
                  md={24}
                  lg={24}
                  xl={24}
                  xxl={24}
                  className="mt-3"
                >
                  <Row className="" gutter={[16, 16]} wrap>
                    {enquireTravellers &&
                      enquireTravellers.map((room, typeIndex) => {
                        return (
                          <Col
                            md={6}
                            sm={24}
                            xs={24}
                            lg={6}
                            xl={6}
                            xxl={6}
                            className="pr-3 package-fonts"
                            key={typeIndex}
                          >
                            <div className="w-[100%]">
                              <h1
                                style={{
                                  display: "inline-block",
                                  width: "max-content",
                                }}
                                className="text-[12px] mb-2 text-center font-semibold"
                              >
                                {room.typeName}
                              </h1>
                              <div className="w-[104%] flex pl-3 pr-3 rounded-md border border-1 border-lightgray-500 bg-[#ffffff]">
                                <h1
                                  onClick={() =>
                                    handleEnquireChange(typeIndex, -1)
                                  }
                                  className="cursor-pointer text-[18px] text-[#eb3e43] font-semibold pt-2 pb-1 pr-2 pl-0 border border-r-1 border-y-0 border-l-0 border-lightgray-500 purchase-label font-semibold"
                                >
                                  -
                                </h1>
                                <h1 className="text-[18px] pt-2 pb-1 pr-4 pl-4">
                                  {room.count}
                                </h1>
                                <h1
                                  onClick={() =>
                                    handleEnquireChange(typeIndex, 1)
                                  }
                                  className="cursor-pointer text-[16px] text-[#eb3e43] font-semibold pt-2 pb-1 pr-2 pl-2 border border-l-1 border-y-0 border-r-0 purchase-label font-semibold"
                                >
                                  +
                                </h1>
                              </div>
                            </div>
                          </Col>
                        );
                      })}
                  </Row>
                </Col>
              </Row>
              <Row className="mt-6">
                <Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24}>
                  <div
                    style={{
                      borderRadius: "22px",
                      pointerEvents: enquireNowButtonDisabled ? "none" : "",
                      opacity: enquireNowButtonDisabled ? 1 : "",
                    }}
                    onClick={() => {
                      enquireNowDetails();
                    }}
                    className="w-[100%] cursor-pointer p-1 package-fonts text-center text-[18px] bg-[#eb3e43] text-[white]"
                  >
                    Enquire Now
                  </div>
                </Col>
              </Row>
            </Col>
          </Modal>
          {/* Enquire modal */}
          <Modal
            open={shareModal}
            title={
              <p className="package-fonts text-[18px]">Share Through Email</p>
            }
            maskClosable={false}
            onClose={() => setShareModal(false)}
            closable
            onCancel={() => setShareModal(false)}
            footer={null}
            className="package-fonts mt-[-60px]"
            closeIcon
            width={550}
          >
            <Divider
              style={{
                width: "110%",
                marginLeft: "-24px",
              }}
            />
            <Col md={24} sm={24} lg={24} xl={24} xxl={24} className="">
              <Row>
                <Col
                  md={12}
                  sm={24}
                  lg={12}
                  xl={12}
                  xxl={12}
                  xs={24}
                  className="pr-3"
                >
                  <Typography className="package-fonts mb-2">
                    Sender Name
                  </Typography>
                  <Input
                    name="senderName"
                    value={senderName}
                    onChange={(e) => setSenderName(e.target.value)}
                    // disabled
                    placeholder="Enter your name"
                    style={{
                      height: "40px",
                      fontFamily: "Poppins",
                      paddingLeft: "8px",
                    }}
                    className="text-[14px] package-fonts"
                  />
                  {shareValidations === true && senderName === "" ? (
                    <p
                      style={{
                        display: "inline-block",
                      }}
                      className="text-start input-label text-[#ff0000] mt-2 mb-1 text-[11px]"
                    >
                      The sender name field is required
                    </p>
                  ) : (
                    ""
                  )}
                </Col>
                <Col
                  md={12}
                  sm={24}
                  lg={12}
                  xl={12}
                  xxl={12}
                  xs={24}
                  className="pr-3"
                >
                  <Typography className="package-fonts text-[14px] mb-2">
                    Sender Email
                  </Typography>
                  <Input
                    name="senderEmail"
                    value={senderEmail}
                    style={{
                      height: "40px",
                      fontFamily: "Poppins",
                    }}
                    onChange={validationSenderEmailChange}
                    placeholder="Enter your email id"
                    id="main-sender-email-input"
                    className="package-fonts text-[14px]"
                    suffix={
                      <MailFilled className="text-[14px] text-[#818181]" />
                    }
                  />
                  <div id="error-sender-email-panel">
                    {senderEmailValidations == true ? (
                      <p className="input-label text-[11px] text-start text-[#ff0000]">
                        The email field is not valid
                      </p>
                    ) : shareValidations === true && senderName === "" ? (
                      <p
                        style={{
                          display: "inline-block",
                        }}
                        className="text-start input-label text-[#ff0000] mt-2 mb-1 text-[11px]"
                      >
                        The sender email field is required
                      </p>
                    ) : (
                      ""
                    )}
                  </div>
                </Col>
                <Col
                  md={12}
                  sm={24}
                  lg={12}
                  xl={12}
                  xxl={12}
                  xs={24}
                  className="mt-1 pr-3"
                >
                  <Typography className="package-fonts mb-2">
                    Receiver Name
                  </Typography>
                  <Input
                    name="receiverName"
                    value={receiverName}
                    onChange={(e) => setReceiverName(e.target.value)}
                    // disabled
                    placeholder="Enter receiver name"
                    style={{
                      height: "40px",
                      fontFamily: "Poppins",
                      paddingLeft: "8px",
                      // pointerEvents: "none",
                      // opacity: 1,
                    }}
                    className="text-[14px] package-fonts"
                  />
                  {shareValidations === true && receiverName === "" ? (
                    <p
                      style={{
                        display: "inline-block",
                      }}
                      className="text-start input-label text-[#ff0000] mt-2 mb-1 text-[11px]"
                    >
                      The receiver name field is required
                    </p>
                  ) : (
                    ""
                  )}
                </Col>
                <Col
                  md={12}
                  sm={24}
                  lg={12}
                  xl={12}
                  xxl={12}
                  xs={24}
                  className="mt-1 pr-3"
                >
                  <Typography className="package-fonts text-[14px] mb-2">
                    Receiver Email
                  </Typography>
                  <Input
                    name="receiverEmail"
                    value={receiverEmail}
                    style={{
                      height: "40px",
                      fontFamily: "Poppins",
                    }}
                    onChange={validationReceiverEmailChange}
                    placeholder="Enter receiver email id"
                    id="main-receiver-email-input"
                    className="package-fonts text-[14px]"
                    suffix={
                      <MailFilled className="text-[14px] text-[#818181]" />
                    }
                  />
                  <div id="error-receiver-email-panel">
                    {receiverEmailValidations == true ? (
                      <p className="input-label text-[11px] text-start text-[#ff0000]">
                        The email field is not valid
                      </p>
                    ) : shareValidations === true && receiverName === "" ? (
                      <p
                        style={{
                          display: "inline-block",
                        }}
                        className="text-start input-label text-[#ff0000] mt-2 mb-1 text-[11px]"
                      >
                        The receiver email field is required
                      </p>
                    ) : (
                      ""
                    )}
                  </div>
                </Col>
              </Row>
              <Row>
                <Col>
                  <div
                    className="mb-2 mt-3 cursor-pointer package-fonts text-[13px] font-semibold text-[#eb3e43]"
                    onClick={() => addReceiver()}
                  >
                    + ADD CC
                  </div>
                </Col>
              </Row>

              {receiverDetails && receiverDetails.length > 0
                ? receiverDetails.map((data, index) => {
                    return (
                      <Row className="w-[100%]" key={index}>
                        <Col
                          md={11}
                          sm={22}
                          lg={11}
                          xl={11}
                          xxl={11}
                          xs={22}
                          className="mt-1 pr-3"
                        >
                          <Typography className="package-fonts mb-2">
                            Receiver Name
                          </Typography>
                          <Input
                            name="name"
                            value={data.name}
                            onChange={(e) =>
                              shareDetailsChange(e, "name", index)
                            }
                            // disabled
                            placeholder="Enter receiver name"
                            style={{
                              height: "40px",
                              fontFamily: "Poppins",
                              paddingLeft: "8px",
                              // pointerEvents: "none",
                              // opacity: 1,
                            }}
                            className="text-[14px] package-fonts"
                          />
                        </Col>
                        <Col
                          md={11}
                          sm={24}
                          lg={11}
                          xl={11}
                          xxl={11}
                          xs={24}
                          className="mt-1 pr-3"
                        >
                          <Typography className="package-fonts text-[14px] mb-2">
                            Receiver Email
                          </Typography>
                          <Input
                            name="email"
                            value={data.email}
                            style={{
                              height: "40px",
                              fontFamily: "Poppins",
                            }}
                            onChange={(e) =>
                              shareDetailsChange(e, "email", index)
                            }
                            placeholder="Enter receiver email id"
                            id="main-receiver-data-email-input"
                            className="package-fonts text-[14px]"
                            suffix={
                              <MailFilled className="text-[14px] text-[#818181]" />
                            }
                          />
                          <div id={index}>
                            {receiverDataEmailValidations == true ? (
                              <p className="input-label text-[11px] text-start text-[#ff0000]">
                                The email field is not valid
                              </p>
                            ) : (
                              ""
                            )}
                          </div>
                        </Col>
                        <Col md={2} sm={2} lg={2} xl={2} xxl={2} xs={2}>
                          <div
                            className="cursor-pointer package-fonts text-[14px] mt-[42px] ml-[10px] text-[#eb3e43]"
                            onClick={() => {
                              const array = [...receiverDetails];
                              array.splice(index, 1); // Remove the row at the specified index
                              setReceiverDetails(array);

                              setPageRender(!pageRender);
                            }}
                          >
                            <CloseOutlined />
                          </div>
                        </Col>
                      </Row>
                    );
                  })
                : ""}
            </Col>
            <Divider
              style={{
                width: "110%",
                marginLeft: "-24px",
              }}
            />
            <Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24}>
              <Row className="mt-1">
                <Col
                  xs={24}
                  sm={24}
                  md={24}
                  lg={24}
                  xl={24}
                  xxl={24}
                  className="flex justify-end"
                >
                  <div
                    style={{
                      borderRadius: "22px",
                      // pointerEvents: enquireNowButtonDisabled ? "none" : "",
                      // opacity: enquireNowButtonDisabled ? 1 : "",
                    }}
                    onClick={() => {
                      setShareModal(false);
                    }}
                    className="mr-2 cursor-pointer pl-3 pr-3 pt-1 pb-1 package-fonts text-center text-[14px] bg-[white] border border-red-1 text-[eb3e43]"
                  >
                    Cancel
                  </div>
                  <div
                    style={{
                      borderRadius: "22px",
                      pointerEvents: sharePackageButtonDisabled ? "none" : "",
                      opacity: sharePackageButtonDisabled ? 1 : "",
                    }}
                    onClick={() => {
                      sharePackageDetails();
                    }}
                    className="cursor-pointer pl-3 pr-3 pt-1 pb-1 package-fonts text-center text-[14px] bg-[#eb3e43] text-[white]"
                  >
                    {sharePackageButtonDisabled ? "Sharing...." : "Share Now"}
                  </div>
                </Col>
              </Row>
            </Col>
          </Modal>
          <Modal
            open={chatModal}
            title=""
            maskClosable={false}
            onClose={() => setChatModal(false)}
            // onCancel={() => setChatModal(false)}
            // onCancel={false}
            closable
            footer={null}
            closeIcon={
              <CloseOutlined
                onClick={() => setChatModal(false)}
                className="text-[#ffffff]"
              />
            }
            width={500}
          >
            {/* <Divider
            style={{
              borderWidth: "0.2px",
              width: "108.5%",
              marginLeft: "-24px",
            }}
          /> */}
            <Col sm={24} md={24} lg={24} xl={24} xxl={24}>
              <div className="w-[107%] ml-[-20px] mt-[-16px] h-[200px] global-modal-img rounded-md">
                <Row>
                  <Col
                    style={{
                      fontFamily: "Poppins",
                    }}
                    md={12}
                    sm={12}
                    lg={12}
                    xl={12}
                    xxl={12}
                    className="p-3"
                  >
                    <h2 className="text-[#ffffff]">
                      Don't miss out on our exclusive deals & insider only
                      offers!
                    </h2>
                    <div className="text-[#ffffff] mt-2">
                      <div className="flex">
                        <p>
                          <IoShieldCheckmarkSharp className="mt-1 text-[red] mr-2" />
                        </p>
                        5 years of Experience in India
                      </div>
                      <div className="flex">
                        <p>
                          <IoShieldCheckmarkSharp className="mt-1 text-[red] mr-2" />
                        </p>
                        Packages across 50 + Countries
                      </div>
                      <div className="flex">
                        <p>
                          <IoShieldCheckmarkSharp className="mt-1 text-[red] mr-2" />
                        </p>
                        Best Travel Partner of India
                      </div>
                    </div>
                  </Col>
                  <Col md={12} sm={12} lg={12} xl={12} xxl={12}></Col>
                </Row>
              </div>
            </Col>

            {/* <Collapse
            items={paymentFaqList}
            expandIcon={<DownCircleOutlined />}
            expandIconPosition="right"
            className="font-semibold"
            bordered
            style={{
              fontFamily: "Poppins",
            }}
          /> */}
          </Modal>
          <FloatButton
            className="w-[50px] h-[50px]"
            type="primary"
            style={{
              margin: "-7px",
            }}
            onClick={() => {
              addEquireForm();
            }}
            icon={<CommentOutlined />}
          />
        </Col>
      </Row>
    </React.Fragment>
  );
};

PackageDetailsList.propTypes = {
  location: PropTypes.any,
};

export default withRouter(PackageDetailsList);
